import {NAMES} from "./constants";

export const lossDataNewSet3 = {
  "Jan 01 2025": {
    [NAMES.TROOPS]: 790800,
    [NAMES.TANKS]: 9672,
    [NAMES.BMP_BTR]: 20043,
    [NAMES.ARTA]: 21532,
    [NAMES.PPO]: 1032,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 330,
    [NAMES.UAV]: 21131,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 32675
  },
  "Jan 02 2025": {
    [NAMES.TROOPS]: 792170,
    [NAMES.TANKS]: 9676,
    [NAMES.BMP_BTR]: 20056,
    [NAMES.ARTA]: 21552,
    [NAMES.PPO]: 1032,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 330,
    [NAMES.UAV]: 21200,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 32729
  },
  "Jan 03 2025": {
    [NAMES.TROOPS]: 793250,
    [NAMES.TANKS]: 9677,
    [NAMES.BMP_BTR]: 20070,
    [NAMES.ARTA]: 21555,
    [NAMES.PPO]: 1032,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 330,
    [NAMES.UAV]: 21249,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 32770
  },
  "Jan 04 2025": {
    [NAMES.TROOPS]: 794760,
    [NAMES.TANKS]: 9679,
    [NAMES.BMP_BTR]: 20093,
    [NAMES.ARTA]: 21578,
    [NAMES.PPO]: 1032,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21356,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 32843
  },
  "Jan 05 2025": {
    [NAMES.TROOPS]: 796490,
    [NAMES.TANKS]: 9686,
    [NAMES.BMP_BTR]: 20119,
    [NAMES.ARTA]: 21603,
    [NAMES.PPO]: 1032,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21447,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 32940
  },
  "Jan 06 2025": {
    [NAMES.TROOPS]: 798040,
    [NAMES.TANKS]: 9700,
    [NAMES.BMP_BTR]: 20164,
    [NAMES.ARTA]: 21665,
    [NAMES.PPO]: 1034,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21625,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33056
  },
  "Jan 07 2025": {
    [NAMES.TROOPS]: 800010,
    [NAMES.TANKS]: 9710,
    [NAMES.BMP_BTR]: 20189,
    [NAMES.ARTA]: 21710,
    [NAMES.PPO]: 1038,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21708,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33226
  },
  "Jan 08 2025": {
    [NAMES.TROOPS]: 801670,
    [NAMES.TANKS]: 9714,
    [NAMES.BMP_BTR]: 20205,
    [NAMES.ARTA]: 21729,
    [NAMES.PPO]: 1038,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21727,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33307
  },
  "Jan 09 2025": {
    [NAMES.TROOPS]: 803100,
    [NAMES.TANKS]: 9731,
    [NAMES.BMP_BTR]: 20221,
    [NAMES.ARTA]: 21765,
    [NAMES.PPO]: 1038,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21813,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33387
  },
  "Jan 10 2025": {
    [NAMES.TROOPS]: 804930,
    [NAMES.TANKS]: 9741,
    [NAMES.BMP_BTR]: 20253,
    [NAMES.ARTA]: 21789,
    [NAMES.PPO]: 1041,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21884,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33473
  },
  "Jan 11 2025": {
    [NAMES.TROOPS]: 806500,
    [NAMES.TANKS]: 9751,
    [NAMES.BMP_BTR]: 20271,
    [NAMES.ARTA]: 21817,
    [NAMES.PPO]: 1042,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 21958,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33534
  },
  "Jan 12 2025": {
    [NAMES.TROOPS]: 808250,
    [NAMES.TANKS]: 9756,
    [NAMES.BMP_BTR]: 20289,
    [NAMES.ARTA]: 21839,
    [NAMES.PPO]: 1042,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22021,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33598
  },
  "Jan 13 2025": {
    [NAMES.TROOPS]: 809760,
    [NAMES.TANKS]: 9764,
    [NAMES.BMP_BTR]: 20315,
    [NAMES.ARTA]: 21876,
    [NAMES.PPO]: 1044,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22204,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33708
  },
  "Jan 14 2025": {
    [NAMES.TROOPS]: 811090,
    [NAMES.TANKS]: 9767,
    [NAMES.BMP_BTR]: 20326,
    [NAMES.ARTA]: 21923,
    [NAMES.PPO]: 1044,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22276,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33791
  },
  "Jan 15 2025": {
    [NAMES.TROOPS]: 812670,
    [NAMES.TANKS]: 9780,
    [NAMES.BMP_BTR]: 20348,
    [NAMES.ARTA]: 21975,
    [NAMES.PPO]: 1046,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22383,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 33995
  },
  "Jan 16 2025": {
    [NAMES.TROOPS]: 814150,
    [NAMES.TANKS]: 9791,
    [NAMES.BMP_BTR]: 20368,
    [NAMES.ARTA]: 22015,
    [NAMES.PPO]: 1046,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22503,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34132
  },
  "Jan 17 2025": {
    [NAMES.TROOPS]: 815820,
    [NAMES.TANKS]: 9803,
    [NAMES.BMP_BTR]: 20381,
    [NAMES.ARTA]: 22019,
    [NAMES.PPO]: 1046,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22566,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34256
  },
  "Jan 18 2025": {
    [NAMES.TROOPS]: 817160,
    [NAMES.TANKS]: 9803,
    [NAMES.BMP_BTR]: 20394,
    [NAMES.ARTA]: 22040,
    [NAMES.PPO]: 1046,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22579,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34325
  },
  "Jan 19 2025": {
    [NAMES.TROOPS]: 818740,
    [NAMES.TANKS]: 9811,
    [NAMES.BMP_BTR]: 20412,
    [NAMES.ARTA]: 22055,
    [NAMES.PPO]: 1046,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22615,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34401
  },
  "Jan 20 2025": {
    [NAMES.TROOPS]: 820430,
    [NAMES.TANKS]: 9821,
    [NAMES.BMP_BTR]: 20454,
    [NAMES.ARTA]: 22074,
    [NAMES.PPO]: 1049,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22768,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34488
  },
  "Jan 21 2025": {
    [NAMES.TROOPS]: 822030,
    [NAMES.TANKS]: 9833,
    [NAMES.BMP_BTR]: 20477,
    [NAMES.ARTA]: 22134,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 22898,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34682
  },
  "Jan 22 2025": {
    [NAMES.TROOPS]: 823980,
    [NAMES.TANKS]: 9844,
    [NAMES.BMP_BTR]: 20485,
    [NAMES.ARTA]: 22194,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23039,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34837
  },
  "Jan 23 2025": {
    [NAMES.TROOPS]: 825320,
    [NAMES.TANKS]: 9850,
    [NAMES.BMP_BTR]: 20497,
    [NAMES.ARTA]: 22256,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23111,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34905
  },
  "Jan 24 2025": {
    [NAMES.TROOPS]: 826820,
    [NAMES.TANKS]: 9852,
    [NAMES.BMP_BTR]: 20508,
    [NAMES.ARTA]: 22295,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23162,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 34992
  },
  "Jan 25 2025": {
    [NAMES.TROOPS]: 828470,
    [NAMES.TANKS]: 9859,
    [NAMES.BMP_BTR]: 20545,
    [NAMES.ARTA]: 22309,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23213,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35071
  },
  "Jan 26 2025": {
    [NAMES.TROOPS]: 830190,
    [NAMES.TANKS]: 9868,
    [NAMES.BMP_BTR]: 20549,
    [NAMES.ARTA]: 22323,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23253,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35124
  },
  "Jan 27 2025": {
    [NAMES.TROOPS]: 831620,
    [NAMES.TANKS]: 9871,
    [NAMES.BMP_BTR]: 20561,
    [NAMES.ARTA]: 22339,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23327,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35183
  },
  "Jan 28 2025": {
    [NAMES.TROOPS]: 833000,
    [NAMES.TANKS]: 9876,
    [NAMES.BMP_BTR]: 20573,
    [NAMES.ARTA]: 22366,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23399,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35269
  },
  "Jan 29 2025": {
    [NAMES.TROOPS]: 834670,
    [NAMES.TANKS]: 9886,
    [NAMES.BMP_BTR]: 20597,
    [NAMES.ARTA]: 22395,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23456,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35366
  },
  "Jan 30 2025": {
    [NAMES.TROOPS]: 835940,
    [NAMES.TANKS]: 9890,
    [NAMES.BMP_BTR]: 20614,
    [NAMES.ARTA]: 22412,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23510,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35451
  },
  "Jan 31 2025": {
    [NAMES.TROOPS]: 837610,
    [NAMES.TANKS]: 9893,
    [NAMES.BMP_BTR]: 20631,
    [NAMES.ARTA]: 22445,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23573,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35552
  },
  "Feb 01 2025": {
    [NAMES.TROOPS]: 839040,
    [NAMES.TANKS]: 9902,
    [NAMES.BMP_BTR]: 20653,
    [NAMES.ARTA]: 22493,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23694,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35629
  },
  "Feb 02 2025": {
    [NAMES.TROOPS]: 840360,
    [NAMES.TANKS]: 9908,
    [NAMES.BMP_BTR]: 20667,
    [NAMES.ARTA]: 22538,
    [NAMES.PPO]: 1050,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23793,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35709
  },
  "Feb 03 2025": {
    [NAMES.TROOPS]: 841660,
    [NAMES.TANKS]: 9920,
    [NAMES.BMP_BTR]: 20685,
    [NAMES.ARTA]: 22598,
    [NAMES.PPO]: 1053,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 23911,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35798
  },
  "Feb 04 2025": {
    [NAMES.TROOPS]: 842930,
    [NAMES.TANKS]: 9938,
    [NAMES.BMP_BTR]: 20709,
    [NAMES.ARTA]: 22655,
    [NAMES.PPO]: 1053,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24003,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 35921
  },
  "Feb 05 2025": {
    [NAMES.TROOPS]: 844070,
    [NAMES.TANKS]: 9947,
    [NAMES.BMP_BTR]: 20721,
    [NAMES.ARTA]: 22707,
    [NAMES.PPO]: 1053,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24102,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36078
  },
  "Feb 06 2025": {
    [NAMES.TROOPS]: 845310,
    [NAMES.TANKS]: 9965,
    [NAMES.BMP_BTR]: 20737,
    [NAMES.ARTA]: 22753,
    [NAMES.PPO]: 1055,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24185,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36211
  },
  "Feb 07 2025": {
    [NAMES.TROOPS]: 846650,
    [NAMES.TANKS]: 9975,
    [NAMES.BMP_BTR]: 20755,
    [NAMES.ARTA]: 22785,
    [NAMES.PPO]: 1056,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24301,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36307
  },
  "Feb 08 2025": {
    [NAMES.TROOPS]: 847860,
    [NAMES.TANKS]: 9981,
    [NAMES.BMP_BTR]: 20777,
    [NAMES.ARTA]: 22820,
    [NAMES.PPO]: 1056,
    [NAMES.JETS]: 369,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24403,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36402
  },
  "Feb 09 2025": {
    [NAMES.TROOPS]: 849320,
    [NAMES.TANKS]: 9992,
    [NAMES.BMP_BTR]: 20797,
    [NAMES.ARTA]: 22844,
    [NAMES.PPO]: 1056,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24486,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36529
  },
  "Feb 10 2025": {
    [NAMES.TROOPS]: 850490,
    [NAMES.TANKS]: 10001,
    [NAMES.BMP_BTR]: 20813,
    [NAMES.ARTA]: 22879,
    [NAMES.PPO]: 1059,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24623,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36638
  },
  "Feb 11 2025": {
    [NAMES.TROOPS]: 851880,
    [NAMES.TANKS]: 10014,
    [NAMES.BMP_BTR]: 20844,
    [NAMES.ARTA]: 22923,
    [NAMES.PPO]: 1060,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24755,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36807
  },
  "Feb 12 2025": {
    [NAMES.TROOPS]: 853030,
    [NAMES.TANKS]: 10023,
    [NAMES.BMP_BTR]: 20871,
    [NAMES.ARTA]: 22976,
    [NAMES.PPO]: 1061,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 24919,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 36928
  },
  "Feb 13 2025": {
    [NAMES.TROOPS]: 854280,
    [NAMES.TANKS]: 10040,
    [NAMES.BMP_BTR]: 20894,
    [NAMES.ARTA]: 23034,
    [NAMES.PPO]: 1063,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25072,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37096
  },
  "Feb 14 2025": {
    [NAMES.TROOPS]: 855480,
    [NAMES.TANKS]: 10057,
    [NAMES.BMP_BTR]: 20910,
    [NAMES.ARTA]: 23115,
    [NAMES.PPO]: 1066,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25224,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37252
  },
  "Feb 15 2025": {
    [NAMES.TROOPS]: 856660,
    [NAMES.TANKS]: 10068,
    [NAMES.BMP_BTR]: 20927,
    [NAMES.ARTA]: 23174,
    [NAMES.PPO]: 1067,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25341,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37379
  },
  "Feb 16 2025": {
    [NAMES.TROOPS]: 858390,
    [NAMES.TANKS]: 10073,
    [NAMES.BMP_BTR]: 21011,
    [NAMES.ARTA]: 23185,
    [NAMES.PPO]: 1067,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25377,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37456
  },
  "Feb 17 2025": {
    [NAMES.TROOPS]: 859920,
    [NAMES.TANKS]: 10089,
    [NAMES.BMP_BTR]: 21063,
    [NAMES.ARTA]: 23222,
    [NAMES.PPO]: 1067,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25505,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37605
  },
  "Feb 18 2025": {
    [NAMES.TROOPS]: 861090,
    [NAMES.TANKS]: 10101,
    [NAMES.BMP_BTR]: 21075,
    [NAMES.ARTA]: 23275,
    [NAMES.PPO]: 1068,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25686,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37679
  },
  "Feb 19 2025": {
    [NAMES.TROOPS]: 862390,
    [NAMES.TANKS]: 10120,
    [NAMES.BMP_BTR]: 21098,
    [NAMES.ARTA]: 23347,
    [NAMES.PPO]: 1072,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 25861,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37825
  },
  "Feb 20 2025": {
    [NAMES.TROOPS]: 863580,
    [NAMES.TANKS]: 10134,
    [NAMES.BMP_BTR]: 21112,
    [NAMES.ARTA]: 23410,
    [NAMES.PPO]: 1078,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26021,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 37961
  },
  "Feb 21 2025": {
    [NAMES.TROOPS]: 864860,
    [NAMES.TANKS]: 10146,
    [NAMES.BMP_BTR]: 21130,
    [NAMES.ARTA]: 23462,
    [NAMES.PPO]: 1080,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26156,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38104
  },
  "Feb 22 2025": {
    [NAMES.TROOPS]: 866000,
    [NAMES.TANKS]: 10161,
    [NAMES.BMP_BTR]: 21139,
    [NAMES.ARTA]: 23528,
    [NAMES.PPO]: 1080,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26311,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38243
  },
  "Feb 23 2025": {
    [NAMES.TROOPS]: 867180,
    [NAMES.TANKS]: 10168,
    [NAMES.BMP_BTR]: 21151,
    [NAMES.ARTA]: 23582,
    [NAMES.PPO]: 1081,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26428,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38334
  },
  "Feb 24 2025": {
    [NAMES.TROOPS]: 868230,
    [NAMES.TANKS]: 10177,
    [NAMES.BMP_BTR]: 21157,
    [NAMES.ARTA]: 23626,
    [NAMES.PPO]: 1081,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26445,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38444
  },
  "Feb 25 2025": {
    [NAMES.TROOPS]: 869530,
    [NAMES.TANKS]: 10182,
    [NAMES.BMP_BTR]: 21168,
    [NAMES.ARTA]: 23652,
    [NAMES.PPO]: 1083,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26767,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38582
  },
  "Feb 26 2025": {
    [NAMES.TROOPS]: 870700,
    [NAMES.TANKS]: 10201,
    [NAMES.BMP_BTR]: 21183,
    [NAMES.ARTA]: 23686,
    [NAMES.PPO]: 1085,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 26961,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38702
  },
  "Feb 27 2025": {
    [NAMES.TROOPS]: 871850,
    [NAMES.TANKS]: 10209,
    [NAMES.BMP_BTR]: 21196,
    [NAMES.ARTA]: 23755,
    [NAMES.PPO]: 1086,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27102,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38842
  },
  "Feb 28 2025": {
    [NAMES.TROOPS]: 874560,
    [NAMES.TANKS]: 10222,
    [NAMES.BMP_BTR]: 21234,
    [NAMES.ARTA]: 23847,
    [NAMES.PPO]: 1087,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27274,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 38994
  },
  "Mar 01 2025": {
    [NAMES.TROOPS]: 875610,
    [NAMES.TANKS]: 10233,
    [NAMES.BMP_BTR]: 21249,
    [NAMES.ARTA]: 23908,
    [NAMES.PPO]: 1088,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27402,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39101
  },
  "Mar 02 2025": {
    [NAMES.TROOPS]: 876720,
    [NAMES.TANKS]: 10241,
    [NAMES.BMP_BTR]: 21274,
    [NAMES.ARTA]: 23959,
    [NAMES.PPO]: 1091,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27594,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39218
  },
  "Mar 03 2025": {
    [NAMES.TROOPS]: 878070,
    [NAMES.TANKS]: 10252,
    [NAMES.BMP_BTR]: 21290,
    [NAMES.ARTA]: 24019,
    [NAMES.PPO]: 1093,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27655,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39327
  },
  "Mar 04 2025": {
    [NAMES.TROOPS]: 879410,
    [NAMES.TANKS]: 10255,
    [NAMES.BMP_BTR]: 21298,
    [NAMES.ARTA]: 24064,
    [NAMES.PPO]: 1094,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27741,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39428
  },
  "Mar 05 2025": {
    [NAMES.TROOPS]: 880660,
    [NAMES.TANKS]: 10256,
    [NAMES.BMP_BTR]: 21304,
    [NAMES.ARTA]: 24087,
    [NAMES.PPO]: 1094,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27849,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39512
  },
  "Mar 06 2025": {
    [NAMES.TROOPS]: 881800,
    [NAMES.TANKS]: 10261,
    [NAMES.BMP_BTR]: 21311,
    [NAMES.ARTA]: 24108,
    [NAMES.PPO]: 1096,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 27929,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39606
  },
  "Mar 07 2025": {
    [NAMES.TROOPS]: 882950,
    [NAMES.TANKS]: 10264,
    [NAMES.BMP_BTR]: 21334,
    [NAMES.ARTA]: 24124,
    [NAMES.PPO]: 1096,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28024,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39678
  },
  "Mar 08 2025": {
    [NAMES.TROOPS]: 883950,
    [NAMES.TANKS]: 10268,
    [NAMES.BMP_BTR]: 21346,
    [NAMES.ARTA]: 24148,
    [NAMES.PPO]: 1099,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28172,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39791
  },
  "Mar 09 2025": {
    [NAMES.TROOPS]: 885130,
    [NAMES.TANKS]: 10274,
    [NAMES.BMP_BTR]: 21360,
    [NAMES.ARTA]: 24206,
    [NAMES.PPO]: 1101,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28362,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 39933
  },
  "Mar 10 2025": {
    [NAMES.TROOPS]: 886320,
    [NAMES.TANKS]: 10292,
    [NAMES.BMP_BTR]: 21400,
    [NAMES.ARTA]: 24271,
    [NAMES.PPO]: 1102,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28603,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40071
  },
  "Mar 11 2025": {
    [NAMES.TROOPS]: 887620,
    [NAMES.TANKS]: 10303,
    [NAMES.BMP_BTR]: 21423,
    [NAMES.ARTA]: 24346,
    [NAMES.PPO]: 1103,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28801,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40205
  },
  "Mar 12 2025": {
    [NAMES.TROOPS]: 889050,
    [NAMES.TANKS]: 10306,
    [NAMES.BMP_BTR]: 21430,
    [NAMES.ARTA]: 24390,
    [NAMES.PPO]: 1103,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28912,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40274
  },
  "Mar 13 2025": {
    [NAMES.TROOPS]: 890250,
    [NAMES.TANKS]: 10307,
    [NAMES.BMP_BTR]: 21432,
    [NAMES.ARTA]: 24409,
    [NAMES.PPO]: 1103,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 28983,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40355
  },
  "Mar 14 2025": {
    [NAMES.TROOPS]: 891660,
    [NAMES.TANKS]: 10313,
    [NAMES.BMP_BTR]: 21443,
    [NAMES.ARTA]: 24455,
    [NAMES.PPO]: 1103,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29136,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40469
  },
  "Mar 15 2025": {
    [NAMES.TROOPS]: 892840,
    [NAMES.TANKS]: 10315,
    [NAMES.BMP_BTR]: 21458,
    [NAMES.ARTA]: 24483,
    [NAMES.PPO]: 1103,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29233,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40571
  },
  "Mar 16 2025": {
    [NAMES.TROOPS]: 894240,
    [NAMES.TANKS]: 10325,
    [NAMES.BMP_BTR]: 21478,
    [NAMES.ARTA]: 24561,
    [NAMES.PPO]: 1104,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29413,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40684
  },
  "Mar 17 2025": {
    [NAMES.TROOPS]: 895450,
    [NAMES.TANKS]: 10344,
    [NAMES.BMP_BTR]: 21488,
    [NAMES.ARTA]: 24598,
    [NAMES.PPO]: 1104,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29467,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40785
  },
  "Mar 18 2025": {
    [NAMES.TROOPS]: 897010,
    [NAMES.TANKS]: 10352,
    [NAMES.BMP_BTR]: 21509,
    [NAMES.ARTA]: 24640,
    [NAMES.PPO]: 1107,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29616,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 40892
  },
  "Mar 19 2025": {
    [NAMES.TROOPS]: 898070,
    [NAMES.TANKS]: 10364,
    [NAMES.BMP_BTR]: 21523,
    [NAMES.ARTA]: 24704,
    [NAMES.PPO]: 1107,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29716,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41003
  },
  "Mar 20 2025": {
    [NAMES.TROOPS]: 899470,
    [NAMES.TANKS]: 10377,
    [NAMES.BMP_BTR]: 21561,
    [NAMES.ARTA]: 24747,
    [NAMES.PPO]: 1110,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 29895,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41094
  },
  "Mar 21 2025": {
    [NAMES.TROOPS]: 900800,
    [NAMES.TANKS]: 10394,
    [NAMES.BMP_BTR]: 21589,
    [NAMES.ARTA]: 24848,
    [NAMES.PPO]: 1111,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 30080,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41259
  },
  "Mar 22 2025": {
    [NAMES.TROOPS]: 902010,
    [NAMES.TANKS]: 10403,
    [NAMES.BMP_BTR]: 21609,
    [NAMES.ARTA]: 24944,
    [NAMES.PPO]: 1111,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 30338,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41425
  },
  "Mar 23 2025": {
    [NAMES.TROOPS]: 903480,
    [NAMES.TANKS]: 10412,
    [NAMES.BMP_BTR]: 21636,
    [NAMES.ARTA]: 25048,
    [NAMES.PPO]: 1116,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 331,
    [NAMES.UAV]: 30495,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41610
  },
  "Mar 24 2025": {
    [NAMES.TROOPS]: 904760,
    [NAMES.TANKS]: 10420,
    [NAMES.BMP_BTR]: 21652,
    [NAMES.ARTA]: 25129,
    [NAMES.PPO]: 1117,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 30641,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41726
  },
  "Mar 25 2025": {
    [NAMES.TROOPS]: 905940,
    [NAMES.TANKS]: 10425,
    [NAMES.BMP_BTR]: 21670,
    [NAMES.ARTA]: 25190,
    [NAMES.PPO]: 1117,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 30759,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41824
  },
  "Mar 26 2025": {
    [NAMES.TROOPS]: 907220,
    [NAMES.TANKS]: 10430,
    [NAMES.BMP_BTR]: 21685,
    [NAMES.ARTA]: 25207,
    [NAMES.PPO]: 1117,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 30818,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 41901
  },
  "Mar 27 2025": {
    [NAMES.TROOPS]: 908890,
    [NAMES.TANKS]: 10438,
    [NAMES.BMP_BTR]: 21701,
    [NAMES.ARTA]: 25265,
    [NAMES.PPO]: 1118,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 30926,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42070
  },
  "Mar 28 2025": {
    [NAMES.TROOPS]: 910750,
    [NAMES.TANKS]: 10455,
    [NAMES.BMP_BTR]: 21762,
    [NAMES.ARTA]: 25387,
    [NAMES.PPO]: 1119,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31070,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42280
  },
  "Mar 29 2025": {
    [NAMES.TROOPS]: 912490,
    [NAMES.TANKS]: 10478,
    [NAMES.BMP_BTR]: 21796,
    [NAMES.ARTA]: 25451,
    [NAMES.PPO]: 1122,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31234,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42398
  },
  "Mar 30 2025": {
    [NAMES.TROOPS]: 914000,
    [NAMES.TANKS]: 10492,
    [NAMES.BMP_BTR]: 21816,
    [NAMES.ARTA]: 25507,
    [NAMES.PPO]: 1122,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31345,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42528
  },
  "Mar 31 2025": {
    [NAMES.TROOPS]: 915230,
    [NAMES.TANKS]: 10496,
    [NAMES.BMP_BTR]: 21819,
    [NAMES.ARTA]: 25537,
    [NAMES.PPO]: 1123,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31416,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42593
  },
  "Apr 1 2025": {
    [NAMES.TROOPS]: 916770,
    [NAMES.TANKS]: 10505,
    [NAMES.BMP_BTR]: 21856,
    [NAMES.ARTA]: 25552,
    [NAMES.PPO]: 1123,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31462,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42646
  },
  "Apr 2 2025": {
    [NAMES.TROOPS]: 918180,
    [NAMES.TANKS]: 10515,
    [NAMES.BMP_BTR]: 21880,
    [NAMES.ARTA]: 25576,
    [NAMES.PPO]: 1123,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31505,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42687
  },
  "Apr 3 2025": {
    [NAMES.TROOPS]: 919570,
    [NAMES.TANKS]: 10521,
    [NAMES.BMP_BTR]: 21902,
    [NAMES.ARTA]: 25625,
    [NAMES.PPO]: 1123,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31597,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42775
  },
  "Apr 4 2025": {
    [NAMES.TROOPS]: 920950,
    [NAMES.TANKS]: 10528,
    [NAMES.BMP_BTR]: 21932,
    [NAMES.ARTA]: 25663,
    [NAMES.PPO]: 1123,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31669,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42841
  },
  "Apr 5 2025": {
    [NAMES.TROOPS]: 922340,
    [NAMES.TANKS]: 10541,
    [NAMES.BMP_BTR]: 21952,
    [NAMES.ARTA]: 25730,
    [NAMES.PPO]: 1124,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31778,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 42954
  },
  "Apr 6 2025": {
    [NAMES.TROOPS]: 923670,
    [NAMES.TANKS]: 10554,
    [NAMES.BMP_BTR]: 21972,
    [NAMES.ARTA]: 25786,
    [NAMES.PPO]: 1124,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31846,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43050
  },
  "Apr 7 2025": {
    [NAMES.TROOPS]: 925020,
    [NAMES.TANKS]: 10567,
    [NAMES.BMP_BTR]: 21997,
    [NAMES.ARTA]: 25817,
    [NAMES.PPO]: 1124,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31874,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43120
  },
  "Apr 8 2025": {
    [NAMES.TROOPS]: 926310,
    [NAMES.TANKS]: 10572,
    [NAMES.BMP_BTR]: 22011,
    [NAMES.ARTA]: 25860,
    [NAMES.PPO]: 1126,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31917,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43227
  },
  "Apr 9 2025": {
    [NAMES.TROOPS]: 927580,
    [NAMES.TANKS]: 10576,
    [NAMES.BMP_BTR]: 22021,
    [NAMES.ARTA]: 25912,
    [NAMES.PPO]: 1127,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 31973,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43345
  },
  "Apr 10 2025": {
    [NAMES.TROOPS]: 929000,
    [NAMES.TANKS]: 10579,
    [NAMES.BMP_BTR]: 22033,
    [NAMES.ARTA]: 25982,
    [NAMES.PPO]: 1127,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32078,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43514
  },
  "Apr 11 2025": {
    [NAMES.TROOPS]: 930210,
    [NAMES.TANKS]: 10580,
    [NAMES.BMP_BTR]: 22048,
    [NAMES.ARTA]: 26043,
    [NAMES.PPO]: 1127,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32200,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43679
  },
  "Apr 12 2025": {
    [NAMES.TROOPS]: 931450,
    [NAMES.TANKS]: 10591,
    [NAMES.BMP_BTR]: 22055,
    [NAMES.ARTA]: 26092,
    [NAMES.PPO]: 1127,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32278,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43807
  },
  "Apr 13 2025": {
    [NAMES.TROOPS]: 932670,
    [NAMES.TANKS]: 10603,
    [NAMES.BMP_BTR]: 22088,
    [NAMES.ARTA]: 26163,
    [NAMES.PPO]: 1128,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32425,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 43950
  },
  "Apr 14 2025": {
    [NAMES.TROOPS]: 933980,
    [NAMES.TANKS]: 10622,
    [NAMES.BMP_BTR]: 22130,
    [NAMES.ARTA]: 26222,
    [NAMES.PPO]: 1130,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32544,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 44129
  },
  "Apr 15 2025": {
    [NAMES.TROOPS]: 935160,
    [NAMES.TANKS]: 10629,
    [NAMES.BMP_BTR]: 22150,
    [NAMES.ARTA]: 26290,
    [NAMES.PPO]: 1132,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32691,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 44339
  },
  "Apr 16 2025": {
    [NAMES.TROOPS]: 936210,
    [NAMES.TANKS]: 10638,
    [NAMES.BMP_BTR]: 22163,
    [NAMES.ARTA]: 26377,
    [NAMES.PPO]: 1132,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32837,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 44472
  },
  "Apr 17 2025": {
    [NAMES.TROOPS]: 937440,
    [NAMES.TANKS]: 10654,
    [NAMES.BMP_BTR]: 22217,
    [NAMES.ARTA]: 26442,
    [NAMES.PPO]: 1135,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 32925,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 44642
  },
  "Apr 18 2025": {
    [NAMES.TROOPS]: 938970,
    [NAMES.TANKS]: 10662,
    [NAMES.BMP_BTR]: 22257,
    [NAMES.ARTA]: 26530,
    [NAMES.PPO]: 1136,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33065,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 44954
  },
  "Apr 19 2025": {
    [NAMES.TROOPS]: 940150,
    [NAMES.TANKS]: 10676,
    [NAMES.BMP_BTR]: 22266,
    [NAMES.ARTA]: 26600,
    [NAMES.PPO]: 1139,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33176,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45162
  },
  "Apr 20 2025": {
    [NAMES.TROOPS]: 941100,
    [NAMES.TANKS]: 10677,
    [NAMES.BMP_BTR]: 22271,
    [NAMES.ARTA]: 26649,
    [NAMES.PPO]: 1139,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33240,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45274
  },
  "Apr 21 2025": {
    [NAMES.TROOPS]: 941770,
    [NAMES.TANKS]: 10679,
    [NAMES.BMP_BTR]: 22273,
    [NAMES.ARTA]: 26659,
    [NAMES.PPO]: 1139,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33270,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45324
  },
  "Apr 22 2025": {
    [NAMES.TROOPS]: 943060,
    [NAMES.TANKS]: 10683,
    [NAMES.BMP_BTR]: 22296,
    [NAMES.ARTA]: 26689,
    [NAMES.PPO]: 1140,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33388,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45458
  },
  "Apr 23 2025": {
    [NAMES.TROOPS]: 944270,
    [NAMES.TANKS]: 10691,
    [NAMES.BMP_BTR]: 22307,
    [NAMES.ARTA]: 26774,
    [NAMES.PPO]: 1141,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33526,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45621
  },
  "Apr 24 2025": {
    [NAMES.TROOPS]: 945330,
    [NAMES.TANKS]: 10694,
    [NAMES.BMP_BTR]: 22312,
    [NAMES.ARTA]: 26823,
    [NAMES.PPO]: 1141,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33660,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45755
  },
  "Apr 25 2025": {
    [NAMES.TROOPS]: 946500,
    [NAMES.TANKS]: 10703,
    [NAMES.BMP_BTR]: 22315,
    [NAMES.ARTA]: 26895,
    [NAMES.PPO]: 1144,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33779,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 45906
  },
  "Apr 26 2025": {
    [NAMES.TROOPS]: 947610,
    [NAMES.TANKS]: 10711,
    [NAMES.BMP_BTR]: 22320,
    [NAMES.ARTA]: 26965,
    [NAMES.PPO]: 1145,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 33897,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46051
  },
  "Apr 27 2025": {
    [NAMES.TROOPS]: 948640,
    [NAMES.TANKS]: 10719,
    [NAMES.BMP_BTR]: 22325,
    [NAMES.ARTA]: 27007,
    [NAMES.PPO]: 1145,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34011,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46187
  },
  "Apr 28 2025": {
    [NAMES.TROOPS]: 949800,
    [NAMES.TANKS]: 10723,
    [NAMES.BMP_BTR]: 22338,
    [NAMES.ARTA]: 27038,
    [NAMES.PPO]: 1145,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34083,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46292
  },
  "Apr 29 2025": {
    [NAMES.TROOPS]: 950860,
    [NAMES.TANKS]: 10728,
    [NAMES.BMP_BTR]: 22352,
    [NAMES.ARTA]: 27080,
    [NAMES.PPO]: 1146,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34177,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46432
  },
  "Apr 30 2025": {
    [NAMES.TROOPS]: 951960,
    [NAMES.TANKS]: 10729,
    [NAMES.BMP_BTR]: 22353,
    [NAMES.ARTA]: 27091,
    [NAMES.PPO]: 1146,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34289,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46611
  },
  "May 01 2025": {
    [NAMES.TROOPS]: 953190,
    [NAMES.TANKS]: 10732,
    [NAMES.BMP_BTR]: 22364,
    [NAMES.ARTA]: 27136,
    [NAMES.PPO]: 1148,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34401,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46750
  },
  "May 02 2025": {
    [NAMES.TROOPS]: 954300,
    [NAMES.TANKS]: 10741,
    [NAMES.BMP_BTR]: 22369,
    [NAMES.ARTA]: 27186,
    [NAMES.PPO]: 1152,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34539,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 46882
  },
  "May 03 2025": {
    [NAMES.TROOPS]: 955470,
    [NAMES.TANKS]: 10745,
    [NAMES.BMP_BTR]: 22369,
    [NAMES.ARTA]: 27234,
    [NAMES.PPO]: 1153,
    [NAMES.JETS]: 370,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34665,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47003
  },
  "May 04 2025": {
    [NAMES.TROOPS]: 956810,
    [NAMES.TANKS]: 10758,
    [NAMES.BMP_BTR]: 22403,
    [NAMES.ARTA]: 27327,
    [NAMES.PPO]: 1155,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34860,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47141
  },
  "May 05 2025": {
    [NAMES.TROOPS]: 958070,
    [NAMES.TANKS]: 10763,
    [NAMES.BMP_BTR]: 22411,
    [NAMES.ARTA]: 27370,
    [NAMES.PPO]: 1155,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 34997,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47250
  },
  "May 06 2025": {
    [NAMES.TROOPS]: 959500,
    [NAMES.TANKS]: 10766,
    [NAMES.BMP_BTR]: 22416,
    [NAMES.ARTA]: 27431,
    [NAMES.PPO]: 1155,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35142,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47353
  },
  "May 07 2025": {
    [NAMES.TROOPS]: 960770,
    [NAMES.TANKS]: 10780,
    [NAMES.BMP_BTR]: 22419,
    [NAMES.ARTA]: 27502,
    [NAMES.PPO]: 1155,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35266,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47484
  },
  "May 08 2025": {
    [NAMES.TROOPS]: 961970,
    [NAMES.TANKS]: 10782,
    [NAMES.BMP_BTR]: 22429,
    [NAMES.ARTA]: 27552,
    [NAMES.PPO]: 1156,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35407,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47604
  },
  "May 09 2025": {
    [NAMES.TROOPS]: 963270,
    [NAMES.TANKS]: 10786,
    [NAMES.BMP_BTR]: 22433,
    [NAMES.ARTA]: 27588,
    [NAMES.PPO]: 1157,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35446,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47724
  },
  "May 10 2025": {
    [NAMES.TROOPS]: 964580,
    [NAMES.TANKS]: 10790,
    [NAMES.BMP_BTR]: 22440,
    [NAMES.ARTA]: 27637,
    [NAMES.PPO]: 1158,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35482,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47830
  },
  "May 11 2025": {
    [NAMES.TROOPS]: 965890,
    [NAMES.TANKS]: 10792,
    [NAMES.BMP_BTR]: 22446,
    [NAMES.ARTA]: 27670,
    [NAMES.PPO]: 1159,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35537,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 47947
  },
  "May 12 2025": {
    [NAMES.TROOPS]: 967060,
    [NAMES.TANKS]: 10800,
    [NAMES.BMP_BTR]: 22473,
    [NAMES.ARTA]: 27718,
    [NAMES.PPO]: 1162,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35678,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48118
  },
  "May 13 2025": {
    [NAMES.TROOPS]: 968130,
    [NAMES.TANKS]: 10802,
    [NAMES.BMP_BTR]: 22487,
    [NAMES.ARTA]: 27780,
    [NAMES.PPO]: 1162,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35778,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48256
  },
  "May 14 2025": {
    [NAMES.TROOPS]: 969370,
    [NAMES.TANKS]: 10804,
    [NAMES.BMP_BTR]: 22501,
    [NAMES.ARTA]: 27827,
    [NAMES.PPO]: 1165,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 335,
    [NAMES.UAV]: 35860,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48382
  },
  "May 15 2025": {
    [NAMES.TROOPS]: 970590,
    [NAMES.TANKS]: 10812,
    [NAMES.BMP_BTR]: 22514,
    [NAMES.ARTA]: 27872,
    [NAMES.PPO]: 1166,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36000,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48547
  },
  "May 16 2025": {
    [NAMES.TROOPS]: 971690,
    [NAMES.TANKS]: 10825,
    [NAMES.BMP_BTR]: 22546,
    [NAMES.ARTA]: 27908,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36123,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48713
  },
  "May 17 2025": {
    [NAMES.TROOPS]: 972600,
    [NAMES.TANKS]: 10831,
    [NAMES.BMP_BTR]: 22553,
    [NAMES.ARTA]: 27942,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36278,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48809
  },
  "May 18 2025": {
    [NAMES.TROOPS]: 973730,
    [NAMES.TANKS]: 10832,
    [NAMES.BMP_BTR]: 22557,
    [NAMES.ARTA]: 27980,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36385,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48900
  },
  "May 19 2025": {
    [NAMES.TROOPS]: 974770,
    [NAMES.TANKS]: 10833,
    [NAMES.BMP_BTR]: 22562,
    [NAMES.ARTA]: 28009,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36503,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 48988
  },
  "May 20 2025": {
    [NAMES.TROOPS]: 975800,
    [NAMES.TANKS]: 10834,
    [NAMES.BMP_BTR]: 22567,
    [NAMES.ARTA]: 28067,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36621,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49093
  },
  "May 21 2025": {
    [NAMES.TROOPS]: 976780,
    [NAMES.TANKS]: 10835,
    [NAMES.BMP_BTR]: 22569,
    [NAMES.ARTA]: 28090,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36692,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49169
  },
  "May 22 2025": {
    [NAMES.TROOPS]: 977650,
    [NAMES.TANKS]: 10839,
    [NAMES.BMP_BTR]: 22574,
    [NAMES.ARTA]: 28122,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36797,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49268
  },
  "May 23 2025": {
    [NAMES.TROOPS]: 978700,
    [NAMES.TANKS]: 10841,
    [NAMES.BMP_BTR]: 22575,
    [NAMES.ARTA]: 28165,
    [NAMES.PPO]: 1167,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 36945,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49407
  },
  "May 24 2025": {
    [NAMES.TROOPS]: 979830,
    [NAMES.TANKS]: 10852,
    [NAMES.BMP_BTR]: 22622,
    [NAMES.ARTA]: 28201,
    [NAMES.PPO]: 1169,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37177,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49639
  },
  "May 25 2025": {
    [NAMES.TROOPS]: 980850,
    [NAMES.TANKS]: 10854,
    [NAMES.BMP_BTR]: 22633,
    [NAMES.ARTA]: 28269,
    [NAMES.PPO]: 1169,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37367,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49751
  },
  "May 26 2025": {
    [NAMES.TROOPS]: 981850,
    [NAMES.TANKS]: 10858,
    [NAMES.BMP_BTR]: 22641,
    [NAMES.ARTA]: 28320,
    [NAMES.PPO]: 1171,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37631,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49843
  },
  "May 27 2025": {
    [NAMES.TROOPS]: 982840,
    [NAMES.TANKS]: 10860,
    [NAMES.BMP_BTR]: 22642,
    [NAMES.ARTA]: 28337,
    [NAMES.PPO]: 1171,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37853,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49907
  },
  "May 28 2025": {
    [NAMES.TROOPS]: 983890,
    [NAMES.TANKS]: 10864,
    [NAMES.BMP_BTR]: 22644,
    [NAMES.ARTA]: 28355,
    [NAMES.PPO]: 1171,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37918,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 49959
  },
  "May 29 2025": {
    [NAMES.TROOPS]: 984940,
    [NAMES.TANKS]: 10864,
    [NAMES.BMP_BTR]: 22645,
    [NAMES.ARTA]: 28386,
    [NAMES.PPO]: 1171,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 37999,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50015
  },
  "May 30 2025": {
    [NAMES.TROOPS]: 986080,
    [NAMES.TANKS]: 10865,
    [NAMES.BMP_BTR]: 22647,
    [NAMES.ARTA]: 28421,
    [NAMES.PPO]: 1172,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38070,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50089
  },
  "May 31 2025": {
    [NAMES.TROOPS]: 987330,
    [NAMES.TANKS]: 10867,
    [NAMES.BMP_BTR]: 22652,
    [NAMES.ARTA]: 28475,
    [NAMES.PPO]: 1173,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38215,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50198
  },
  "Jun 01 2025": {
    [NAMES.TROOPS]: 988560,
    [NAMES.TANKS]: 10872,
    [NAMES.BMP_BTR]: 22656,
    [NAMES.ARTA]: 28527,
    [NAMES.PPO]: 1173,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38366,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50325
  },
  "Jun 02 2025": {
    [NAMES.TROOPS]: 989700,
    [NAMES.TANKS]: 10874,
    [NAMES.BMP_BTR]: 22663,
    [NAMES.ARTA]: 28575,
    [NAMES.PPO]: 1175,
    [NAMES.JETS]: 372,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38622,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50462
  },
  "Jun 03 2025": {
    [NAMES.TROOPS]: 990800,
    [NAMES.TANKS]: 10881,
    [NAMES.BMP_BTR]: 22671,
    [NAMES.ARTA]: 28623,
    [NAMES.PPO]: 1176,
    [NAMES.JETS]: 384,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38748,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50607
  },
  "Jun 04 2025": {
    [NAMES.TROOPS]: 991820,
    [NAMES.TANKS]: 10884,
    [NAMES.BMP_BTR]: 22678,
    [NAMES.ARTA]: 28711,
    [NAMES.PPO]: 1176,
    [NAMES.JETS]: 413,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 38924,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50730
  },
  "Jun 05 2025": {
    [NAMES.TROOPS]: 992750,
    [NAMES.TANKS]: 10887,
    [NAMES.BMP_BTR]: 22680,
    [NAMES.ARTA]: 28750,
    [NAMES.PPO]: 1177,
    [NAMES.JETS]: 413,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 39019,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50812
  },
  "Jun 06 2025": {
    [NAMES.TROOPS]: 993910,
    [NAMES.TANKS]: 10889,
    [NAMES.BMP_BTR]: 22685,
    [NAMES.ARTA]: 28794,
    [NAMES.PPO]: 1180,
    [NAMES.JETS]: 413,
    [NAMES.HELI]: 336,
    [NAMES.UAV]: 39193,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 50913
  },
  "Jun 07 2025": {
    [NAMES.TROOPS]: 995030,
    [NAMES.TANKS]: 10904,
    [NAMES.BMP_BTR]: 22737,
    [NAMES.ARTA]: 28850,
    [NAMES.PPO]: 1181,
    [NAMES.JETS]: 413,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 39493,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51079
  },
  "Jun 08 2025": {
    [NAMES.TROOPS]: 996150,
    [NAMES.TANKS]: 10911,
    [NAMES.BMP_BTR]: 22748,
    [NAMES.ARTA]: 28892,
    [NAMES.PPO]: 1183,
    [NAMES.JETS]: 414,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 39651,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51225
  },
  "Jun 09 2025": {
    [NAMES.TROOPS]: 997120,
    [NAMES.TANKS]: 10915,
    [NAMES.BMP_BTR]: 22759,
    [NAMES.ARTA]: 28934,
    [NAMES.PPO]: 1183,
    [NAMES.JETS]: 414,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 39818,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51348
  },
  "Jun 10 2025": {
    [NAMES.TROOPS]: 998080,
    [NAMES.TANKS]: 10919,
    [NAMES.BMP_BTR]: 22768,
    [NAMES.ARTA]: 28982,
    [NAMES.PPO]: 1183,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40057,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51455
  },
  "Jun 11 2025": {
    [NAMES.TROOPS]: 999290,
    [NAMES.TANKS]: 10927,
    [NAMES.BMP_BTR]: 22783,
    [NAMES.ARTA]: 29016,
    [NAMES.PPO]: 1183,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40297,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51579
  },
  "Jun 12 2025": {
    [NAMES.TROOPS]: 1000340,
    [NAMES.TANKS]: 10933,
    [NAMES.BMP_BTR]: 22786,
    [NAMES.ARTA]: 29063,
    [NAMES.PPO]: 1184,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40435,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51715
  },
  "Jun 13 2025": {
    [NAMES.TROOPS]: 1001560,
    [NAMES.TANKS]: 10934,
    [NAMES.BMP_BTR]: 22791,
    [NAMES.ARTA]: 29105,
    [NAMES.PPO]: 1184,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40507,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51821
  },
  "Jun 14 2025": {
    [NAMES.TROOPS]: 1002690,
    [NAMES.TANKS]: 10937,
    [NAMES.BMP_BTR]: 22798,
    [NAMES.ARTA]: 29157,
    [NAMES.PPO]: 1185,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40586,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 51928
  },
  "Jun 15 2025": {
    [NAMES.TROOPS]: 1003860,
    [NAMES.TANKS]: 10937,
    [NAMES.BMP_BTR]: 22804,
    [NAMES.ARTA]: 29190,
    [NAMES.PPO]: 1186,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40709,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52017
  },
  "Jun 16 2025": {
    [NAMES.TROOPS]: 1005060,
    [NAMES.TANKS]: 10939,
    [NAMES.BMP_BTR]: 22811,
    [NAMES.ARTA]: 29208,
    [NAMES.PPO]: 1187,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40804,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52096
  },
  "Jun 17 2025": {
    [NAMES.TROOPS]: 1006120,
    [NAMES.TANKS]: 10940,
    [NAMES.BMP_BTR]: 22814,
    [NAMES.ARTA]: 29228,
    [NAMES.PPO]: 1187,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 40981,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52175
  },
  "Jun 18 2025": {
    [NAMES.TROOPS]: 1007160,
    [NAMES.TANKS]: 10947,
    [NAMES.BMP_BTR]: 22845,
    [NAMES.ARTA]: 29265,
    [NAMES.PPO]: 1187,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41165,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52312
  },
  "Jun 19 2025": {
    [NAMES.TROOPS]: 1008240,
    [NAMES.TANKS]: 10951,
    [NAMES.BMP_BTR]: 22853,
    [NAMES.ARTA]: 29328,
    [NAMES.PPO]: 1187,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41229,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52420
  },
  "Jun 20 2025": {
    [NAMES.TROOPS]: 1009330,
    [NAMES.TANKS]: 10954,
    [NAMES.BMP_BTR]: 22860,
    [NAMES.ARTA]: 29374,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41299,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52501
  },
  "Jun 21 2025": {
    [NAMES.TROOPS]: 1010390,
    [NAMES.TANKS]: 10955,
    [NAMES.BMP_BTR]: 22865,
    [NAMES.ARTA]: 29393,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41422,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52617
  },
  "Jun 22 2025": {
    [NAMES.TROOPS]: 1011490,
    [NAMES.TANKS]: 10964,
    [NAMES.BMP_BTR]: 22867,
    [NAMES.ARTA]: 29432,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41579,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52734
  },
  "Jun 23 2025": {
    [NAMES.TROOPS]: 1012500,
    [NAMES.TANKS]: 10965,
    [NAMES.BMP_BTR]: 22872,
    [NAMES.ARTA]: 29490,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 41717,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52861
  },
  "Jun 24 2025": {
    [NAMES.TROOPS]: 1013700,
    [NAMES.TANKS]: 10966,
    [NAMES.BMP_BTR]: 22879,
    [NAMES.ARTA]: 29511,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42915,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 52961
  },
  "Jun 25 2025": {
    [NAMES.TROOPS]: 1014650,
    [NAMES.TANKS]: 10967,
    [NAMES.BMP_BTR]: 22885,
    [NAMES.ARTA]: 29569,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42046,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53084
  },
  "Jun 26 2025": {
    [NAMES.TROOPS]: 1015750,
    [NAMES.TANKS]: 10968,
    [NAMES.BMP_BTR]: 22892,
    [NAMES.ARTA]: 29617,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42153,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53195
  },
  "Jun 27 2025": {
    [NAMES.TROOPS]: 1016720,
    [NAMES.TANKS]: 10969,
    [NAMES.BMP_BTR]: 22896,
    [NAMES.ARTA]: 29630,
    [NAMES.PPO]: 1188,
    [NAMES.JETS]: 416,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42240,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53284
  },
  "Jun 28 2025": {
    [NAMES.TROOPS]: 1017720,
    [NAMES.TANKS]: 10970,
    [NAMES.BMP_BTR]: 22908,
    [NAMES.ARTA]: 29665,
    [NAMES.PPO]: 1189,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42477,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53415
  },
  "Jun 29 2025": {
    [NAMES.TROOPS]: 1018940,
    [NAMES.TANKS]: 10976,
    [NAMES.BMP_BTR]: 22915,
    [NAMES.ARTA]: 29689,
    [NAMES.PPO]: 1189,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 337,
    [NAMES.UAV]: 42624,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53508
  },
  "Jun 30 2025": {
    [NAMES.TROOPS]: 1020010,
    [NAMES.TANKS]: 10980,
    [NAMES.BMP_BTR]: 22922,
    [NAMES.ARTA]: 29718,
    [NAMES.PPO]: 1190,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 42796,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53593
  },
  "Jul 01 2025": {
    [NAMES.TROOPS]: 1020980,
    [NAMES.TANKS]: 10983,
    [NAMES.BMP_BTR]: 22928,
    [NAMES.ARTA]: 29754,
    [NAMES.PPO]: 1190,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 42940,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53696
  },
  "Jul 02 2025": {
    [NAMES.TROOPS]: 1022090,
    [NAMES.TANKS]: 10985,
    [NAMES.BMP_BTR]: 22931,
    [NAMES.ARTA]: 29794,
    [NAMES.PPO]: 1191,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 43013,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53786
  },
  "Jul 03 2025": {
    [NAMES.TROOPS]: 1023090,
    [NAMES.TANKS]: 10986,
    [NAMES.BMP_BTR]: 22936,
    [NAMES.ARTA]: 29815,
    [NAMES.PPO]: 1191,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 43098,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53887
  },
  "Jul 04 2025": {
    [NAMES.TROOPS]: 1024210,
    [NAMES.TANKS]: 10988,
    [NAMES.BMP_BTR]: 22946,
    [NAMES.ARTA]: 29865,
    [NAMES.PPO]: 1191,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 43303,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 53999
  },
  "Jul 05 2025": {
    [NAMES.TROOPS]: 1025260,
    [NAMES.TANKS]: 10990,
    [NAMES.BMP_BTR]: 22953,
    [NAMES.ARTA]: 29921,
    [NAMES.PPO]: 1191,
    [NAMES.JETS]: 420,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 43609,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54148
  },
  "Jul 06 2025": {
    [NAMES.TROOPS]: 1026440,
    [NAMES.TANKS]: 10992,
    [NAMES.BMP_BTR]: 22956,
    [NAMES.ARTA]: 29960,
    [NAMES.PPO]: 1192,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 43825,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54252
  },
  "Jul 07 2025": {
    [NAMES.TROOPS]: 1027540,
    [NAMES.TANKS]: 10995,
    [NAMES.BMP_BTR]: 22963,
    [NAMES.ARTA]: 29993,
    [NAMES.PPO]: 1192,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 44058,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54370
  },
  "Jul 08 2025": {
    [NAMES.TROOPS]: 1028610,
    [NAMES.TANKS]: 10995,
    [NAMES.BMP_BTR]: 22967,
    [NAMES.ARTA]: 30034,
    [NAMES.PPO]: 1192,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 44230,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54456
  },
  "Jul 09 2025": {
    [NAMES.TROOPS]: 1029660,
    [NAMES.TANKS]: 11000,
    [NAMES.BMP_BTR]: 22969,
    [NAMES.ARTA]: 30102,
    [NAMES.PPO]: 1193,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 44457,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54575
  },
  "Jul 10 2025": {
    [NAMES.TROOPS]: 1030580,
    [NAMES.TANKS]: 11011,
    [NAMES.BMP_BTR]: 22972,
    [NAMES.ARTA]: 30140,
    [NAMES.PPO]: 1193,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 44781,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54656
  },
  "Jul 11 2025": {
    [NAMES.TROOPS]: 1031620,
    [NAMES.TANKS]: 11013,
    [NAMES.BMP_BTR]: 22979,
    [NAMES.ARTA]: 30163,
    [NAMES.PPO]: 1193,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 45003,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54732
  },
  "Jul 12 2025": {
    [NAMES.TROOPS]: 1032690,
    [NAMES.TANKS]: 11013,
    [NAMES.BMP_BTR]: 22980,
    [NAMES.ARTA]: 30194,
    [NAMES.PPO]: 1193,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 45248,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54822
  },
  "Jul 13 2025": {
    [NAMES.TROOPS]: 1033930,
    [NAMES.TANKS]: 11016,
    [NAMES.BMP_BTR]: 22983,
    [NAMES.ARTA]: 30243,
    [NAMES.PPO]: 1194,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 45511,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 54923
  },
  "Jul 14 2025": {
    [NAMES.TROOPS]: 1035060,
    [NAMES.TANKS]: 11019,
    [NAMES.BMP_BTR]: 22987,
    [NAMES.ARTA]: 30294,
    [NAMES.PPO]: 1194,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 45635,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55025
  },
  "Jul 15 2025": {
    [NAMES.TROOPS]: 1036290,
    [NAMES.TANKS]: 11022,
    [NAMES.BMP_BTR]: 22993,
    [NAMES.ARTA]: 30346,
    [NAMES.PPO]: 1194,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 45880,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55147
  },
  "Jul 16 2025": {
    [NAMES.TROOPS]: 1037460,
    [NAMES.TANKS]: 11025,
    [NAMES.BMP_BTR]: 22995,
    [NAMES.ARTA]: 30395,
    [NAMES.PPO]: 1196,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 46164,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55229
  },
  "Jul 17 2025": {
    [NAMES.TROOPS]: 1038650,
    [NAMES.TANKS]: 11029,
    [NAMES.BMP_BTR]: 22996,
    [NAMES.ARTA]: 30438,
    [NAMES.PPO]: 1197,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 46414,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55383
  },
  "Jul 18 2025": {
    [NAMES.TROOPS]: 1039830,
    [NAMES.TANKS]: 11032,
    [NAMES.BMP_BTR]: 23005,
    [NAMES.ARTA]: 30485,
    [NAMES.PPO]: 1197,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 46549,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55494
  },
  "Jul 19 2025": {
    [NAMES.TROOPS]: 1040950,
    [NAMES.TANKS]: 11032,
    [NAMES.BMP_BTR]: 23012,
    [NAMES.ARTA]: 30531,
    [NAMES.PPO]: 1198,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 46712,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55606
  },
  "Jul 20 2025": {
    [NAMES.TROOPS]: 1041990,
    [NAMES.TANKS]: 11035,
    [NAMES.BMP_BTR]: 23021,
    [NAMES.ARTA]: 30583,
    [NAMES.PPO]: 1198,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 46982,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55727
  },
  "Jul 21 2025": {
    [NAMES.TROOPS]: 1043160,
    [NAMES.TANKS]: 11037,
    [NAMES.BMP_BTR]: 23028,
    [NAMES.ARTA]: 30637,
    [NAMES.PPO]: 1199,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47181,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55859
  },
  "Jul 22 2025": {
    [NAMES.TROOPS]: 1044250,
    [NAMES.TANKS]: 11038,
    [NAMES.BMP_BTR]: 23035,
    [NAMES.ARTA]: 30680,
    [NAMES.PPO]: 1199,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47437,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 55953
  },
  "Jul 23 2025": {
    [NAMES.TROOPS]: 1045220,
    [NAMES.TANKS]: 11041,
    [NAMES.BMP_BTR]: 23037,
    [NAMES.ARTA]: 30722,
    [NAMES.PPO]: 1199,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47552,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56041
  },
  "Jul 24 2025": {
    [NAMES.TROOPS]: 1046270,
    [NAMES.TANKS]: 11046,
    [NAMES.BMP_BTR]: 23047,
    [NAMES.ARTA]: 30746,
    [NAMES.PPO]: 1199,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47638,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56137
  },
  "Jul 25 2025": {
    [NAMES.TROOPS]: 1047250,
    [NAMES.TANKS]: 11049,
    [NAMES.BMP_BTR]: 23052,
    [NAMES.ARTA]: 30777,
    [NAMES.PPO]: 1201,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47834,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56213
  },
  "Jul 26 2025": {
    [NAMES.TROOPS]: 1048330,
    [NAMES.TANKS]: 11056,
    [NAMES.BMP_BTR]: 23059,
    [NAMES.ARTA]: 30812,
    [NAMES.PPO]: 1201,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 47959,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56371
  },
  "Jul 27 2025": {
    [NAMES.TROOPS]: 1049250,
    [NAMES.TANKS]: 11057,
    [NAMES.BMP_BTR]: 23063,
    [NAMES.ARTA]: 30822,
    [NAMES.PPO]: 1201,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 48158,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56493
  },
  "Jul 28 2025": {
    [NAMES.TROOPS]: 1050250,
    [NAMES.TANKS]: 11061,
    [NAMES.BMP_BTR]: 23064,
    [NAMES.ARTA]: 30826,
    [NAMES.PPO]: 1201,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 48393,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56596
  },
  "Jul 29 2025": {
    [NAMES.TROOPS]: 1051300,
    [NAMES.TANKS]: 11065,
    [NAMES.BMP_BTR]: 23064,
    [NAMES.ARTA]: 30865,
    [NAMES.PPO]: 1202,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 48585,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56687
  },
  "Jul 30 2025": {
    [NAMES.TROOPS]: 1052190,
    [NAMES.TANKS]: 11066,
    [NAMES.BMP_BTR]: 23065,
    [NAMES.ARTA]: 30895,
    [NAMES.PPO]: 1202,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 48686,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56754
  },
  "Jul 31 2025": {
    [NAMES.TROOPS]: 1053260,
    [NAMES.TANKS]: 11067,
    [NAMES.BMP_BTR]: 23066,
    [NAMES.ARTA]: 30911,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 48894,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56822
  },
  "Aug 01 2025": {
    [NAMES.TROOPS]: 1054200,
    [NAMES.TANKS]: 11068,
    [NAMES.BMP_BTR]: 23068,
    [NAMES.ARTA]: 30944,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49057,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 56894
  },
  "Aug 02 2025": {
    [NAMES.TROOPS]: 1055210,
    [NAMES.TANKS]: 11068,
    [NAMES.BMP_BTR]: 23069,
    [NAMES.ARTA]: 30982,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49196,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57024
  },
  "Aug 03 2025": {
    [NAMES.TROOPS]: 1056130,
    [NAMES.TANKS]: 11068,
    [NAMES.BMP_BTR]: 23071,
    [NAMES.ARTA]: 31025,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49374,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57159
  },
  "Aug 04 2025": {
    [NAMES.TROOPS]: 1057140,
    [NAMES.TANKS]: 11069,
    [NAMES.BMP_BTR]: 23079,
    [NAMES.ARTA]: 31053,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49451,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57244
  },
  "Aug 05 2025": {
    [NAMES.TROOPS]: 1058260,
    [NAMES.TANKS]: 11071,
    [NAMES.BMP_BTR]: 23091,
    [NAMES.ARTA]: 31081,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49620,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57337
  },
  "Aug 06 2025": {
    [NAMES.TROOPS]: 1059270,
    [NAMES.TANKS]: 11072,
    [NAMES.BMP_BTR]: 23091,
    [NAMES.ARTA]: 31133,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49767,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57475
  },
  "Aug 07 2025": {
    [NAMES.TROOPS]: 1060310,
    [NAMES.TANKS]: 11076,
    [NAMES.BMP_BTR]: 23095,
    [NAMES.ARTA]: 31180,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 49930,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57605
  },
  "Aug 08 2025": {
    [NAMES.TROOPS]: 1061350,
    [NAMES.TANKS]: 11083,
    [NAMES.BMP_BTR]: 23102,
    [NAMES.ARTA]: 31232,
    [NAMES.PPO]: 1203,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50168,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57731
  },
  "Aug 09 2025": {
    [NAMES.TROOPS]: 1062290,
    [NAMES.TANKS]: 11088,
    [NAMES.BMP_BTR]: 23103,
    [NAMES.ARTA]: 31273,
    [NAMES.PPO]: 1204,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50315,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57856
  },
  "Aug 10 2025": {
    [NAMES.TROOPS]: 1063240,
    [NAMES.TANKS]: 11089,
    [NAMES.BMP_BTR]: 23107,
    [NAMES.ARTA]: 31343,
    [NAMES.PPO]: 1204,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50455,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 57982
  },
  "Aug 11 2025": {
    [NAMES.TROOPS]: 1064240,
    [NAMES.TANKS]: 11093,
    [NAMES.BMP_BTR]: 23114,
    [NAMES.ARTA]: 31380,
    [NAMES.PPO]: 1204,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50646,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58113
  },
  "Aug 12 2025": {
    [NAMES.TROOPS]: 1065220,
    [NAMES.TANKS]: 11098,
    [NAMES.BMP_BTR]: 23119,
    [NAMES.ARTA]: 31406,
    [NAMES.PPO]: 1205,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50753,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58219
  },
  "Aug 13 2025": {
    [NAMES.TROOPS]: 1066110,
    [NAMES.TANKS]: 11099,
    [NAMES.BMP_BTR]: 23127,
    [NAMES.ARTA]: 31429,
    [NAMES.PPO]: 1207,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 50852,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58265
  },
  "Aug 14 2025": {
    [NAMES.TROOPS]: 1067100,
    [NAMES.TANKS]: 11104,
    [NAMES.BMP_BTR]: 23130,
    [NAMES.ARTA]: 31458,
    [NAMES.PPO]: 1207,
    [NAMES.JETS]: 421,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51043,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58456
  },
  "Aug 15 2025": {
    [NAMES.TROOPS]: 1068040,
    [NAMES.TANKS]: 11106,
    [NAMES.BMP_BTR]: 23133,
    [NAMES.ARTA]: 31498,
    [NAMES.PPO]: 1207,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51190,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58596
  },
  "Aug 16 2025": {
    [NAMES.TROOPS]: 1069050,
    [NAMES.TANKS]: 11112,
    [NAMES.BMP_BTR]: 23135,
    [NAMES.ARTA]: 31540,
    [NAMES.PPO]: 1207,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51342,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58733
  },
  "Aug 17 2025": {
    [NAMES.TROOPS]: 1069950,
    [NAMES.TANKS]: 11116,
    [NAMES.BMP_BTR]: 23143,
    [NAMES.ARTA]: 31589,
    [NAMES.PPO]: 1208,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51528,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58821
  },
  "Aug 18 2025": {
    [NAMES.TROOPS]: 1070890,
    [NAMES.TANKS]: 11118,
    [NAMES.BMP_BTR]: 23148,
    [NAMES.ARTA]: 31632,
    [NAMES.PPO]: 1208,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51685,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 58937
  },
  "Aug 19 2025": {
    [NAMES.TROOPS]: 1071780,
    [NAMES.TANKS]: 11118,
    [NAMES.BMP_BTR]: 23148,
    [NAMES.ARTA]: 31698,
    [NAMES.PPO]: 1208,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 51894,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59060
  },
  "Aug 20 2025": {
    [NAMES.TROOPS]: 1072700,
    [NAMES.TANKS]: 11119,
    [NAMES.BMP_BTR]: 23152,
    [NAMES.ARTA]: 31748,
    [NAMES.PPO]: 1208,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 52154,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59202
  },
  "Aug 21 2025": {
    [NAMES.TROOPS]: 1073530,
    [NAMES.TANKS]: 11120,
    [NAMES.BMP_BTR]: 23157,
    [NAMES.ARTA]: 31789,
    [NAMES.PPO]: 1209,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 52469,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59316
  },
  "Aug 22 2025": {
    [NAMES.TROOPS]: 1074320,
    [NAMES.TANKS]: 11124,
    [NAMES.BMP_BTR]: 23160,
    [NAMES.ARTA]: 31835,
    [NAMES.PPO]: 1210,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 52787,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59426
  },
  "Aug 23 2025": {
    [NAMES.TROOPS]: 1075160,
    [NAMES.TANKS]: 11129,
    [NAMES.BMP_BTR]: 23164,
    [NAMES.ARTA]: 31858,
    [NAMES.PPO]: 1210,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 52935,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59512
  },
  "Aug 24 2025": {
    [NAMES.TROOPS]: 1076070,
    [NAMES.TANKS]: 11129,
    [NAMES.BMP_BTR]: 23167,
    [NAMES.ARTA]: 31898,
    [NAMES.PPO]: 1211,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 53056,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59593
  },
  "Aug 25 2025": {
    [NAMES.TROOPS]: 1076940,
    [NAMES.TANKS]: 11130,
    [NAMES.BMP_BTR]: 23175,
    [NAMES.ARTA]: 31946,
    [NAMES.PPO]: 1211,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 53347,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59672
  },
  "Aug 26 2025": {
    [NAMES.TROOPS]: 1077830,
    [NAMES.TANKS]: 11134,
    [NAMES.BMP_BTR]: 23178,
    [NAMES.ARTA]: 31979,
    [NAMES.PPO]: 1211,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 53442,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59769
  },
  "Aug 27 2025": {
    [NAMES.TROOPS]: 1078750,
    [NAMES.TANKS]: 11135,
    [NAMES.BMP_BTR]: 23178,
    [NAMES.ARTA]: 32024,
    [NAMES.PPO]: 1212,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 53636,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 59887
  },
  "Aug 28 2025": {
    [NAMES.TROOPS]: 1079630,
    [NAMES.TANKS]: 11139,
    [NAMES.BMP_BTR]: 23185,
    [NAMES.ARTA]: 32064,
    [NAMES.PPO]: 1212,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 53961,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60007
  },
  "Aug 29 2025": {
    [NAMES.TROOPS]: 1080480,
    [NAMES.TANKS]: 11143,
    [NAMES.BMP_BTR]: 23191,
    [NAMES.ARTA]: 32125,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 54375,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60116
  },
  "Aug 30 2025": {
    [NAMES.TROOPS]: 1081330,
    [NAMES.TANKS]: 11149,
    [NAMES.BMP_BTR]: 23210,
    [NAMES.ARTA]: 32172,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 54691,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60222
  },
  "Aug 31 2025": {
    [NAMES.TROOPS]: 1082140,
    [NAMES.TANKS]: 11151,
    [NAMES.BMP_BTR]: 23212,
    [NAMES.ARTA]: 32199,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 340,
    [NAMES.UAV]: 55062,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60305
  },
  "Sep 01 2025": {
    [NAMES.TROOPS]: 1082990,
    [NAMES.TANKS]: 11155,
    [NAMES.BMP_BTR]: 23229,
    [NAMES.ARTA]: 32248,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 55276,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60399
  },
  "Sep 02 2025": {
    [NAMES.TROOPS]: 1083790,
    [NAMES.TANKS]: 11156,
    [NAMES.BMP_BTR]: 23233,
    [NAMES.ARTA]: 32301,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 55446,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60488
  },
  "Sep 03 2025": {
    [NAMES.TROOPS]: 1084570,
    [NAMES.TANKS]: 11157,
    [NAMES.BMP_BTR]: 23237,
    [NAMES.ARTA]: 32342,
    [NAMES.PPO]: 1213,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 55784,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60600
  },
  "Sep 04 2025": {
    [NAMES.TROOPS]: 1085410,
    [NAMES.TANKS]: 11157,
    [NAMES.BMP_BTR]: 23241,
    [NAMES.ARTA]: 32385,
    [NAMES.PPO]: 1215,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 56045,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60692
  },
  "Sep 05 2025": {
    [NAMES.TROOPS]: 1086220,
    [NAMES.TANKS]: 11159,
    [NAMES.BMP_BTR]: 23243,
    [NAMES.ARTA]: 32435,
    [NAMES.PPO]: 1216,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 56267,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60831
  },
  "Sep 06 2025": {
    [NAMES.TROOPS]: 1087180,
    [NAMES.TANKS]: 11161,
    [NAMES.BMP_BTR]: 23243,
    [NAMES.ARTA]: 32474,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 56523,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 60950
  },
  "Sep 07 2025": {
    [NAMES.TROOPS]: 1088150,
    [NAMES.TANKS]: 11163,
    [NAMES.BMP_BTR]: 23254,
    [NAMES.ARTA]: 32516,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 56817,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61054
  },
  "Sep 08 2025": {
    [NAMES.TROOPS]: 1089060,
    [NAMES.TANKS]: 11168,
    [NAMES.BMP_BTR]: 23258,
    [NAMES.ARTA]: 32545,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 57278,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61135
  },
  "Sep 09 2025": {
    [NAMES.TROOPS]: 1090010,
    [NAMES.TANKS]: 11169,
    [NAMES.BMP_BTR]: 23261,
    [NAMES.ARTA]: 32577,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 57504,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61207
  },
  "Sep 10 2025": {
    [NAMES.TROOPS]: 1091000,
    [NAMES.TANKS]: 11172,
    [NAMES.BMP_BTR]: 23262,
    [NAMES.ARTA]: 32606,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 57851,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61290
  },
  "Sep 11 2025": {
    [NAMES.TROOPS]: 1091890,
    [NAMES.TANKS]: 11176,
    [NAMES.BMP_BTR]: 23264,
    [NAMES.ARTA]: 32628,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 58194,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61339
  },
  "Sep 12 2025": {
    [NAMES.TROOPS]: 1092780,
    [NAMES.TANKS]: 11177,
    [NAMES.BMP_BTR]: 23266,
    [NAMES.ARTA]: 32668,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 58467,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61403
  },
  "Sep 13 2025": {
    [NAMES.TROOPS]: 1093730,
    [NAMES.TANKS]: 11181,
    [NAMES.BMP_BTR]: 23267,
    [NAMES.ARTA]: 32707,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 58825,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61512
  },
  "Sep 14 2025": {
    [NAMES.TROOPS]: 1094610,
    [NAMES.TANKS]: 11184,
    [NAMES.BMP_BTR]: 23267,
    [NAMES.ARTA]: 32749,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 59086,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61614
  },
  "Sep 15 2025": {
    [NAMES.TROOPS]: 1095520,
    [NAMES.TANKS]: 11184,
    [NAMES.BMP_BTR]: 23269,
    [NAMES.ARTA]: 32784,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 59409,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61698
  },
  "Sep 16 2025": {
    [NAMES.TROOPS]: 1096430,
    [NAMES.TANKS]: 11184,
    [NAMES.BMP_BTR]: 23274,
    [NAMES.ARTA]: 32810,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 59719,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61770
  },
  "Sep 17 2025": {
    [NAMES.TROOPS]: 1097450,
    [NAMES.TANKS]: 11189,
    [NAMES.BMP_BTR]: 23277,
    [NAMES.ARTA]: 32846,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 60079,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 61878
  },
  "Sep 18 2025": {
    [NAMES.TROOPS]: 1098380,
    [NAMES.TANKS]: 11191,
    [NAMES.BMP_BTR]: 23277,
    [NAMES.ARTA]: 32879,
    [NAMES.PPO]: 1217,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 60469,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62000
  },
  "Sep 19 2025": {
    [NAMES.TROOPS]: 1099530,
    [NAMES.TANKS]: 11191,
    [NAMES.BMP_BTR]: 23278,
    [NAMES.ARTA]: 32896,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 60680,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62044
  },
  "Sep 20 2025": {
    [NAMES.TROOPS]: 1100600,
    [NAMES.TANKS]: 11192,
    [NAMES.BMP_BTR]: 23280,
    [NAMES.ARTA]: 32927,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 61045,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62168
  },
  "Sep 21 2025": {
    [NAMES.TROOPS]: 1101610,
    [NAMES.TANKS]: 11193,
    [NAMES.BMP_BTR]: 23281,
    [NAMES.ARTA]: 32952,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 341,
    [NAMES.UAV]: 61598,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62245
  },
  "Sep 22 2025": {
    [NAMES.TROOPS]: 1102570,
    [NAMES.TANKS]: 11194,
    [NAMES.BMP_BTR]: 23282,
    [NAMES.ARTA]: 32999,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 422,
    [NAMES.HELI]: 344,
    [NAMES.UAV]: 62001,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62363
  },
  "Sep 23 2025": {
    [NAMES.TROOPS]: 1103580,
    [NAMES.TANKS]: 11199,
    [NAMES.BMP_BTR]: 23282,
    [NAMES.ARTA]: 33052,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 424,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 62486,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62486
  },
  "Sep 24 2025": {
    [NAMES.TROOPS]: 1104550,
    [NAMES.TANKS]: 11201,
    [NAMES.BMP_BTR]: 23285,
    [NAMES.ARTA]: 33095,
    [NAMES.PPO]: 1218,
    [NAMES.JETS]: 426,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 62820,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62616
  },
  "Sep 25 2025": {
    [NAMES.TROOPS]: 1105490,
    [NAMES.TANKS]: 11201,
    [NAMES.BMP_BTR]: 23287,
    [NAMES.ARTA]: 33133,
    [NAMES.PPO]: 1222,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 63235,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62736
  },
  "Sep 26 2025": {
    [NAMES.TROOPS]: 1106430,
    [NAMES.TANKS]: 11203,
    [NAMES.BMP_BTR]: 23287,
    [NAMES.ARTA]: 33147,
    [NAMES.PPO]: 1222,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 63569,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62818
  },
  "Sep 27 2025": {
    [NAMES.TROOPS]: 1107400,
    [NAMES.TANKS]: 11204,
    [NAMES.BMP_BTR]: 23288,
    [NAMES.ARTA]: 33186,
    [NAMES.PPO]: 1223,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 63931,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 62909
  },
  "Sep 28 2025": {
    [NAMES.TROOPS]: 1108510,
    [NAMES.TANKS]: 11211,
    [NAMES.BMP_BTR]: 23290,
    [NAMES.ARTA]: 33231,
    [NAMES.PPO]: 1223,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 64385,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63040
  },
  "Sep 29 2025": {
    [NAMES.TROOPS]: 1109590,
    [NAMES.TANKS]: 11218,
    [NAMES.BMP_BTR]: 23290,
    [NAMES.ARTA]: 33284,
    [NAMES.PPO]: 1224,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 345,
    [NAMES.UAV]: 65002,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63151
  },
  "Sep 30 2025": {
    [NAMES.TROOPS]: 1110560,
    [NAMES.TANKS]: 11222,
    [NAMES.BMP_BTR]: 23291,
    [NAMES.ARTA]: 33311,
    [NAMES.PPO]: 1224,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 65303,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63241
  },
  "Oct 1 2025": {
    [NAMES.TROOPS]: 1111480,
    [NAMES.TANKS]: 11223,
    [NAMES.BMP_BTR]: 23294,
    [NAMES.ARTA]: 33324,
    [NAMES.PPO]: 1224,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 65552,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63274
  },
  "Oct 2 2025": {
    [NAMES.TROOPS]: 1112460,
    [NAMES.TANKS]: 11224,
    [NAMES.BMP_BTR]: 23296,
    [NAMES.ARTA]: 33336,
    [NAMES.PPO]: 1224,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 65823,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63303
  },
  "Oct 3 2025": {
    [NAMES.TROOPS]: 1113430,
    [NAMES.TANKS]: 11225,
    [NAMES.BMP_BTR]: 23297,
    [NAMES.ARTA]: 33413,
    [NAMES.PPO]: 1222,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 66093,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63325
  },
  "Oct 4 2025": {
    [NAMES.TROOPS]: 1114380,
    [NAMES.TANKS]: 11226,
    [NAMES.BMP_BTR]: 23298,
    [NAMES.ARTA]: 33428,
    [NAMES.PPO]: 1222,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 66543,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63398
  },
  "Oct 5 2025": {
    [NAMES.TROOPS]: 1115250,
    [NAMES.TANKS]: 11230,
    [NAMES.BMP_BTR]: 23299,
    [NAMES.ARTA]: 33446,
    [NAMES.PPO]: 1222,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 66863,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63433
  },
  "Oct 6 2025": {
    [NAMES.TROOPS]: 1116340,
    [NAMES.TANKS]: 11235,
    [NAMES.BMP_BTR]: 23313,
    [NAMES.ARTA]: 33464,
    [NAMES.PPO]: 1223,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 67226,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63496
  },
  "Oct 7 2025": {
    [NAMES.TROOPS]: 1117360,
    [NAMES.TANKS]: 11238,
    [NAMES.BMP_BTR]: 23319,
    [NAMES.ARTA]: 33493,
    [NAMES.PPO]: 1224,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 67564,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63575
  },
  "Oct 8 2025": {
    [NAMES.TROOPS]: 1118370,
    [NAMES.TANKS]: 11240,
    [NAMES.BMP_BTR]: 23324,
    [NAMES.ARTA]: 33519,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 67965,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63650
  },
  "Oct 9 2025": {
    [NAMES.TROOPS]: 1119390,
    [NAMES.TANKS]: 11241,
    [NAMES.BMP_BTR]: 23325,
    [NAMES.ARTA]: 33534,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 68293,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63705
  },
  "Oct 10 2025": {
    [NAMES.TROOPS]: 1120510,
    [NAMES.TANKS]: 11246,
    [NAMES.BMP_BTR]: 23339,
    [NAMES.ARTA]: 33547,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 68547,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63775
  },
  "Oct 11 2025": {
    [NAMES.TROOPS]: 1121570,
    [NAMES.TANKS]: 11247,
    [NAMES.BMP_BTR]: 23345,
    [NAMES.ARTA]: 33568,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 68766,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63847
  },
  "Oct 12 2025": {
    [NAMES.TROOPS]: 1122810,
    [NAMES.TANKS]: 11248,
    [NAMES.BMP_BTR]: 23345,
    [NAMES.ARTA]: 33578,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 69010,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 63934
  },
  "Oct 13 2025": {
    [NAMES.TROOPS]: 1123950,
    [NAMES.TANKS]: 11251,
    [NAMES.BMP_BTR]: 23345,
    [NAMES.ARTA]: 33599,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 69242,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64043
  },
  "Oct 14 2025": {
    [NAMES.TROOPS]: 1125150,
    [NAMES.TANKS]: 11256,
    [NAMES.BMP_BTR]: 23345,
    [NAMES.ARTA]: 33628,
    [NAMES.PPO]: 1225,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 69632,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64188
  },
  "Oct 15 2025": {
    [NAMES.TROOPS]: 1126220,
    [NAMES.TANKS]: 11259,
    [NAMES.BMP_BTR]: 23347,
    [NAMES.ARTA]: 33671,
    [NAMES.PPO]: 1227,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 70021,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64329
  },
  "Oct 16 2025": {
    [NAMES.TROOPS]: 1127300,
    [NAMES.TANKS]: 11261,
    [NAMES.BMP_BTR]: 23384,
    [NAMES.ARTA]: 33713,
    [NAMES.PPO]: 1227,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 70437,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64468
  },
  "Oct 17 2025": {
    [NAMES.TROOPS]: 1128030,
    [NAMES.TANKS]: 11266,
    [NAMES.BMP_BTR]: 23394,
    [NAMES.ARTA]: 33748,
    [NAMES.PPO]: 1228,
    [NAMES.JETS]: 427,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 71025,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64541
  },
  "Oct 18 2025": {
    [NAMES.TROOPS]: 1129180,
    [NAMES.TANKS]: 11267,
    [NAMES.BMP_BTR]: 23396,
    [NAMES.ARTA]: 33789,
    [NAMES.PPO]: 1228,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 71523,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64672
  },
  "Oct 19 2025": {
    [NAMES.TROOPS]: 1130180,
    [NAMES.TANKS]: 11268,
    [NAMES.BMP_BTR]: 23399,
    [NAMES.ARTA]: 33834,
    [NAMES.PPO]: 1228,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 71967,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64798
  },
  "Oct 20 2025": {
    [NAMES.TROOPS]: 1131070,
    [NAMES.TANKS]: 11270,
    [NAMES.BMP_BTR]: 23399,
    [NAMES.ARTA]: 33879,
    [NAMES.PPO]: 1229,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 72365,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 64892
  },
  "Oct 21 2025": {
    [NAMES.TROOPS]: 1132200,
    [NAMES.TANKS]: 11278,
    [NAMES.BMP_BTR]: 23436,
    [NAMES.ARTA]: 33902,
    [NAMES.PPO]: 1229,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 72600,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65026
  },
  "Oct 22 2025": {
    [NAMES.TROOPS]: 1133250,
    [NAMES.TANKS]: 11280,
    [NAMES.BMP_BTR]: 23447,
    [NAMES.ARTA]: 33914,
    [NAMES.PPO]: 1229,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 72760,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65122
  },
  "Oct 23 2025": {
    [NAMES.TROOPS]: 1134170,
    [NAMES.TANKS]: 11282,
    [NAMES.BMP_BTR]: 23453,
    [NAMES.ARTA]: 33938,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 73386,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65228
  },
  "Oct 24 2025": {
    [NAMES.TROOPS]: 1135080,
    [NAMES.TANKS]: 11283,
    [NAMES.BMP_BTR]: 23458,
    [NAMES.ARTA]: 33972,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 73826,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65356,
  },
  "Oct 25 2025": {
    [NAMES.TROOPS]: 1135990,
    [NAMES.TANKS]: 11287,
    [NAMES.BMP_BTR]: 23459,
    [NAMES.ARTA]: 33987,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 74185,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65436,
  },
  "Oct 26 2025": {
    [NAMES.TROOPS]: 1136890,
    [NAMES.TANKS]: 11291,
    [NAMES.BMP_BTR]: 23477,
    [NAMES.ARTA]: 34002,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 74399,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65517,
  },
  "Oct 27 2025": {
    [NAMES.TROOPS]: 1137690,
    [NAMES.TANKS]: 11293,
    [NAMES.BMP_BTR]: 23480,
    [NAMES.ARTA]: 34036,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 74946,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65655,
  },
  "Oct 28 2025": {
    [NAMES.TROOPS]: 1138750,
    [NAMES.TANKS]: 11299,
    [NAMES.BMP_BTR]: 23508,
    [NAMES.ARTA]: 34044,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 75054,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65786,
  },
  "Oct 29 2025": {
    [NAMES.TROOPS]: 1139900,
    [NAMES.TANKS]: 11303,
    [NAMES.BMP_BTR]: 23511,
    [NAMES.ARTA]: 34064,
    [NAMES.PPO]: 1230,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 75367,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65865,
  },
  "Oct 30 2025": {
    [NAMES.TROOPS]: 1140860,
    [NAMES.TANKS]: 11305,
    [NAMES.BMP_BTR]: 23514,
    [NAMES.ARTA]: 34089,
    [NAMES.PPO]: 1232,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 75707,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 65993,
  },
  "Oct 31 2025": {
    [NAMES.TROOPS]: 1141830,
    [NAMES.TANKS]: 11310,
    [NAMES.BMP_BTR]: 23519,
    [NAMES.ARTA]: 34128,
    [NAMES.PPO]: 1233,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 346,
    [NAMES.UAV]: 76355,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66111,
  },
  "Nov 1 2025": {
    [NAMES.TROOPS]: 1142730,
    [NAMES.TANKS]: 11316,
    [NAMES.BMP_BTR]: 23521,
    [NAMES.ARTA]: 34137,
    [NAMES.PPO]: 1235,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 76704,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66169,
  },
  "Nov 2 2025": {
    [NAMES.TROOPS]: 1143670,
    [NAMES.TANKS]: 11316,
    [NAMES.BMP_BTR]: 23525,
    [NAMES.ARTA]: 34162,
    [NAMES.PPO]: 1235,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 77052,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66290,
  },
  "Nov 3 2025": {
    [NAMES.TROOPS]: 1144830,
    [NAMES.TANKS]: 11321,
    [NAMES.BMP_BTR]: 23531,
    [NAMES.ARTA]: 34207,
    [NAMES.PPO]: 1235,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 77435,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66411,
  },
  "Nov 4 2025": {
    [NAMES.TROOPS]: 1145670,
    [NAMES.TANKS]: 11326,
    [NAMES.BMP_BTR]: 23532,
    [NAMES.ARTA]: 34249,
    [NAMES.PPO]: 1235,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 77860,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66504,
  },
  "Nov 5 2025": {
    [NAMES.TROOPS]: 1146570,
    [NAMES.TANKS]: 11329,
    [NAMES.BMP_BTR]: 23535,
    [NAMES.ARTA]: 34273,
    [NAMES.PPO]: 1237,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 78258,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66574,
  },
  "Nov 6 2025": {
    [NAMES.TROOPS]: 1147740,
    [NAMES.TANKS]: 11329,
    [NAMES.BMP_BTR]: 23541,
    [NAMES.ARTA]: 34288,
    [NAMES.PPO]: 1237,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 78430,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66658,
  },
  "Nov 7 2025": {
    [NAMES.TROOPS]: 1148910,
    [NAMES.TANKS]: 11330,
    [NAMES.BMP_BTR]: 23543,
    [NAMES.ARTA]: 34301,
    [NAMES.PPO]: 1238,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 78678,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66723,
  },
  "Nov 8 2025": {
    [NAMES.TROOPS]: 1150100,
    [NAMES.TANKS]: 11330,
    [NAMES.BMP_BTR]: 23544,
    [NAMES.ARTA]: 34321,
    [NAMES.PPO]: 1239,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 78928,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66795,
  },
  "Nov 9 2025": {
    [NAMES.TROOPS]: 1151070,
    [NAMES.TANKS]: 11335,
    [NAMES.BMP_BTR]: 23545,
    [NAMES.ARTA]: 34340,
    [NAMES.PPO]: 1239,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 79368,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66880,
  },
  "Nov 10 2025": {
    [NAMES.TROOPS]: 1152160,
    [NAMES.TANKS]: 11342,
    [NAMES.BMP_BTR]: 23552,
    [NAMES.ARTA]: 34349,
    [NAMES.PPO]: 1239,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 79425,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 66957,
  },
  "Nov 11 2025": {
    [NAMES.TROOPS]: 1153180,
    [NAMES.TANKS]: 11342,
    [NAMES.BMP_BTR]: 23553,
    [NAMES.ARTA]: 34366,
    [NAMES.PPO]: 1239,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 79642,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67036,
  },
  "Nov 12 2025": {
    [NAMES.TROOPS]: 1154180,
    [NAMES.TANKS]: 11342,
    [NAMES.BMP_BTR]: 23556,
    [NAMES.ARTA]: 34379,
    [NAMES.PPO]: 1240,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 79804,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67123,
  },
  "Nov 13 2025": {
    [NAMES.TROOPS]: 1155360,
    [NAMES.TANKS]: 11344,
    [NAMES.BMP_BTR]: 23567,
    [NAMES.ARTA]: 34388,
    [NAMES.PPO]: 1242,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 79945,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67211,
  },
  "Nov 14 2025": {
    [NAMES.TROOPS]: 1156400,
    [NAMES.TANKS]: 11344,
    [NAMES.BMP_BTR]: 23569,
    [NAMES.ARTA]: 34423,
    [NAMES.PPO]: 1242,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 80387,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67306,
  },
  "Nov 15 2025": {
    [NAMES.TROOPS]: 1157400,
    [NAMES.TANKS]: 11350,
    [NAMES.BMP_BTR]: 23588,
    [NAMES.ARTA]: 34443,
    [NAMES.PPO]: 1244,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 80877,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67396,
  },
  "Nov 16 2025": {
    [NAMES.TROOPS]: 1158260,
    [NAMES.TANKS]: 11353,
    [NAMES.BMP_BTR]: 23591,
    [NAMES.ARTA]: 34469,
    [NAMES.PPO]: 1244,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 81286,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67464,
  },
  "Nov 17 2025": {
    [NAMES.TROOPS]: 1159420,
    [NAMES.TANKS]: 11355,
    [NAMES.BMP_BTR]: 23594,
    [NAMES.ARTA]: 34486,
    [NAMES.PPO]: 1246,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 81499,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67536,
  },
  "Nov 18 2025": {
    [NAMES.TROOPS]: 1160380,
    [NAMES.TANKS]: 11355,
    [NAMES.BMP_BTR]: 23594,
    [NAMES.ARTA]: 34499,
    [NAMES.PPO]: 1247,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 81793,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67579,
  },
  "Nov 19 2025": {
    [NAMES.TROOPS]: 1161230,
    [NAMES.TANKS]: 11356,
    [NAMES.BMP_BTR]: 23595,
    [NAMES.ARTA]: 34511,
    [NAMES.PPO]: 1247,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 82086,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67635,
  },
  "Nov 20 2025": {
    [NAMES.TROOPS]: 1162120,
    [NAMES.TANKS]: 11357,
    [NAMES.BMP_BTR]: 23597,
    [NAMES.ARTA]: 34530,
    [NAMES.PPO]: 1247,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 82470,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67703,
  },
  "Nov 21 2025": {
    [NAMES.TROOPS]: 1163170,
    [NAMES.TANKS]: 11357,
    [NAMES.BMP_BTR]: 23600,
    [NAMES.ARTA]: 34550,
    [NAMES.PPO]: 1247,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 82620,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67768,
  },
  "Nov 22 2025": {
    [NAMES.TROOPS]: 1164340,
    [NAMES.TANKS]: 11361,
    [NAMES.BMP_BTR]: 23607,
    [NAMES.ARTA]: 34559,
    [NAMES.PPO]: 1248,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 82842,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67842,
  },
  "Nov 23 2025": {
    [NAMES.TROOPS]: 1165260,
    [NAMES.TANKS]: 11363,
    [NAMES.BMP_BTR]: 23615,
    [NAMES.ARTA]: 34585,
    [NAMES.PPO]: 1248,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 83338,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 67922,
  },
  "Nov 24 2025": {
    [NAMES.TROOPS]: 1166450,
    [NAMES.TANKS]: 11366,
    [NAMES.BMP_BTR]: 23620,
    [NAMES.ARTA]: 34626,
    [NAMES.PPO]: 1248,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 83769,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68006,
  },
  "Nov 25 2025": {
    [NAMES.TROOPS]: 1167570,
    [NAMES.TANKS]: 11368,
    [NAMES.BMP_BTR]: 23624,
    [NAMES.ARTA]: 34644,
    [NAMES.PPO]: 1250,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 84217,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68118,
  },
  "Nov 26 2025": {
    [NAMES.TROOPS]: 1168550,
    [NAMES.TANKS]: 11372,
    [NAMES.BMP_BTR]: 23625,
    [NAMES.ARTA]: 34688,
    [NAMES.PPO]: 1252,
    [NAMES.JETS]: 428,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 84960,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68242,
  },
  "Nov 27 2025": {
    [NAMES.TROOPS]: 1169690,
    [NAMES.TANKS]: 11373,
    [NAMES.BMP_BTR]: 23628,
    [NAMES.ARTA]: 34709,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 85174,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68351,
  },
  "Nov 28 2025": {
    [NAMES.TROOPS]: 1170790,
    [NAMES.TANKS]: 11380,
    [NAMES.BMP_BTR]: 23643,
    [NAMES.ARTA]: 34730,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 85237,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68399,
  },
  "Nov 29 2025": {
    [NAMES.TROOPS]: 1171700,
    [NAMES.TANKS]: 11381,
    [NAMES.BMP_BTR]: 23658,
    [NAMES.ARTA]: 34733,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 85343,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68463,
  },
  "Nov 30 2025": {
    [NAMES.TROOPS]: 1172860,
    [NAMES.TANKS]: 11386,
    [NAMES.BMP_BTR]: 23672,
    [NAMES.ARTA]: 34740,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 85851,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68512,
  },
  "Dec 1 2025": {
    [NAMES.TROOPS]: 1173920,
    [NAMES.TANKS]: 11387,
    [NAMES.BMP_BTR]: 23678,
    [NAMES.ARTA]: 34754,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 86090,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68583,
  },
  "Dec 2 2025": {
    [NAMES.TROOPS]: 1175030,
    [NAMES.TANKS]: 11387,
    [NAMES.BMP_BTR]: 23679,
    [NAMES.ARTA]: 34768,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 86141,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68641,
  },
  "Dec 3 2025": {
    [NAMES.TROOPS]: 1176230,
    [NAMES.TANKS]: 11393,
    [NAMES.BMP_BTR]: 23682,
    [NAMES.ARTA]: 34780,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 86231,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68688,
  },
  "Dec 4 2025": {
    [NAMES.TROOPS]: 1177370,
    [NAMES.TANKS]: 11396,
    [NAMES.BMP_BTR]: 23685,
    [NAMES.ARTA]: 34809,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 430,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 86476,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68813,
  },
  "Dec 5 2025": {
    [NAMES.TROOPS]: 1178610,
    [NAMES.TANKS]: 11396,
    [NAMES.BMP_BTR]: 23686,
    [NAMES.ARTA]: 34843,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 86900,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 68907,
  },
  "Dec 6 2025": {
    [NAMES.TROOPS]: 1179790,
    [NAMES.TANKS]: 11398,
    [NAMES.BMP_BTR]: 23688,
    [NAMES.ARTA]: 34874,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 87387,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69037,
  },
  "Dec 7 2025": {
    [NAMES.TROOPS]: 1180870,
    [NAMES.TANKS]: 11401,
    [NAMES.BMP_BTR]: 23688,
    [NAMES.ARTA]: 34907,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 87927,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69135,
  },
  "Dec 8 2025": {
    [NAMES.TROOPS]: 1181680,
    [NAMES.TANKS]: 11403,
    [NAMES.BMP_BTR]: 23689,
    [NAMES.ARTA]: 34917,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 88457,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69182,
  },
  "Dec 9 2025": {
    [NAMES.TROOPS]: 1182610,
    [NAMES.TANKS]: 11403,
    [NAMES.BMP_BTR]: 23691,
    [NAMES.ARTA]: 34944,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 88889,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69243,
  },
  "Dec 10 2025": {
    [NAMES.TROOPS]: 1183620,
    [NAMES.TANKS]: 11404,
    [NAMES.BMP_BTR]: 23692,
    [NAMES.ARTA]: 34969,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 89066,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69350,
  },
  "Dec 11 2025": {
    [NAMES.TROOPS]: 1185080,
    [NAMES.TANKS]: 11404,
    [NAMES.BMP_BTR]: 23699,
    [NAMES.ARTA]: 34992,
    [NAMES.PPO]: 1253,
    [NAMES.JETS]: 431,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 89148,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69507,
  },
  "Dec 12 2025": {
    [NAMES.TROOPS]: 1186480,
    [NAMES.TANKS]: 11406,
    [NAMES.BMP_BTR]: 23705,
    [NAMES.ARTA]: 35008,
    [NAMES.PPO]: 1256,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 89401,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69614,
  },
  "Dec 13 2025": {
    [NAMES.TROOPS]: 1187780,
    [NAMES.TANKS]: 11409,
    [NAMES.BMP_BTR]: 23714,
    [NAMES.ARTA]: 35032,
    [NAMES.PPO]: 1258,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 89684,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69717,
  },
  "Dec 14 2025": {
    [NAMES.TROOPS]: 1188490,
    [NAMES.TANKS]: 11410,
    [NAMES.BMP_BTR]: 23721,
    [NAMES.ARTA]: 35041,
    [NAMES.PPO]: 1259,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 90124,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 69798,
  },
  "Dec 15 2025": {
    [NAMES.TROOPS]: 1189470,
    [NAMES.TANKS]: 11412,
    [NAMES.BMP_BTR]: 23731,
    [NAMES.ARTA]: 35105,
    [NAMES.PPO]: 1261,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 90777,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 70005,
  },
  "Dec 16 2025": {
    [NAMES.TROOPS]: 1190620,
    [NAMES.TANKS]: 11421,
    [NAMES.BMP_BTR]: 23737,
    [NAMES.ARTA]: 35172,
    [NAMES.PPO]: 1261,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 91219,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70182,
  },
  "Dec 17 2025": {
    [NAMES.TROOPS]: 1192350,
    [NAMES.TANKS]: 11427,
    [NAMES.BMP_BTR]: 23758,
    [NAMES.ARTA]: 35205,
    [NAMES.PPO]: 1262,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 91386,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70361,
  },
  "Dec 18 2025": {
    [NAMES.TROOPS]: 1193300,
    [NAMES.TANKS]: 11432,
    [NAMES.BMP_BTR]: 23758,
    [NAMES.ARTA]: 35232,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 91716,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70480,
  },
  "Dec 19 2025": {
    [NAMES.TROOPS]: 1194520,
    [NAMES.TANKS]: 11433,
    [NAMES.BMP_BTR]: 23768,
    [NAMES.ARTA]: 35250,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 92142,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70591,
  },
  "Dec 20 2025": {
    [NAMES.TROOPS]: 1195610,
    [NAMES.TANKS]: 11433,
    [NAMES.BMP_BTR]: 23769,
    [NAMES.ARTA]: 35287,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 92488,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70721,
  },
  "Dec 21 2025": {
    [NAMES.TROOPS]: 1196740,
    [NAMES.TANKS]: 11435,
    [NAMES.BMP_BTR]: 23770,
    [NAMES.ARTA]: 35298,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 92604,
    [NAMES.SHIPS]: 29,
    [NAMES.AUTO]: 70789,
  },
  "Dec 22 2025": {
    [NAMES.TROOPS]: 1197860,
    [NAMES.TANKS]: 11438,
    [NAMES.BMP_BTR]: 23772,
    [NAMES.ARTA]: 35308,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 432,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 92713,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70853,
  },
  "Dec 23 2025": {
    [NAMES.TROOPS]: 1199280,
    [NAMES.TANKS]: 11446,
    [NAMES.BMP_BTR]: 23792,
    [NAMES.ARTA]: 35331,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 93166,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 70966,
  },
  "Dec 24 2025": {
    [NAMES.TROOPS]: 1200370,
    [NAMES.TANKS]: 11449,
    [NAMES.BMP_BTR]: 23796,
    [NAMES.ARTA]: 35376,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 94197,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71125,
  },
  "Dec 25 2025": {
    [NAMES.TROOPS]: 1201230,
    [NAMES.TANKS]: 11456,
    [NAMES.BMP_BTR]: 23801,
    [NAMES.ARTA]: 35435,
    [NAMES.PPO]: 1263,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 94797,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71274,
  },
  "Dec 26 2025": {
    [NAMES.TROOPS]: 1202070,
    [NAMES.TANKS]: 11459,
    [NAMES.BMP_BTR]: 23804,
    [NAMES.ARTA]: 35509,
    [NAMES.PPO]: 1264,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 95334,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71454,
  },
  "Dec 27 2025": {
    [NAMES.TROOPS]: 1203310,
    [NAMES.TANKS]: 11464,
    [NAMES.BMP_BTR]: 23823,
    [NAMES.ARTA]: 35542,
    [NAMES.PPO]: 1264,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 95539,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71612,
  },
  "Dec 28 2025": {
    [NAMES.TROOPS]: 1204510,
    [NAMES.TANKS]: 11469,
    [NAMES.BMP_BTR]: 23831,
    [NAMES.ARTA]: 35557,
    [NAMES.PPO]: 1264,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 96227,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71778,
  },
  "Dec 29 2025": {
    [NAMES.TROOPS]: 1205690,
    [NAMES.TANKS]: 11472,
    [NAMES.BMP_BTR]: 23837,
    [NAMES.ARTA]: 35570,
    [NAMES.PPO]: 1264,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 96532,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 71891,
  },
  "Dec 30 2025": {
    [NAMES.TROOPS]: 1206910,
    [NAMES.TANKS]: 11477,
    [NAMES.BMP_BTR]: 23841,
    [NAMES.ARTA]: 35589,
    [NAMES.PPO]: 1264,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 96932,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 72010,
  },
  "Dec 31 2025": {
    [NAMES.TROOPS]: 1207910,
    [NAMES.TANKS]: 11481,
    [NAMES.BMP_BTR]: 23845,
    [NAMES.ARTA]: 35642,
    [NAMES.PPO]: 1266,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 97684,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 72247,
  },
  "Jan 01 2026": {
    [NAMES.TROOPS]: 1208970,
    [NAMES.TANKS]: 11488,
    [NAMES.BMP_BTR]: 23849,
    [NAMES.ARTA]: 35678,
    [NAMES.PPO]: 1266,
    [NAMES.JETS]: 434,
    [NAMES.HELI]: 347,
    [NAMES.UAV]: 98453,
    [NAMES.SHIPS]: 30,
    [NAMES.AUTO]: 72418,
  },
  // … (дані тривають по всіх днях) …
  "Mar 22 2026": {
    [NAMES.TROOPS]: 1287880,
    [NAMES.TANKS]: 11793,
    [NAMES.BMP_BTR]: 24263,
    [NAMES.ARTA]: 38638,
    [NAMES.PPO]: 1336,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 190870,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 84639,
  },
  "Mar 23 2026": {
    [NAMES.TROOPS]: 1288850,
    [NAMES.TANKS]: 11794,
    [NAMES.BMP_BTR]: 24268,
    [NAMES.ARTA]: 38662,
    [NAMES.PPO]: 1336,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 192869,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 84775,
  },
  "Mar 24 2026": {
    [NAMES.TROOPS]: 1289740,
    [NAMES.TANKS]: 11800,
    [NAMES.BMP_BTR]: 24271,
    [NAMES.ARTA]: 38695,
    [NAMES.PPO]: 1336,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 193892,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 84955
  },
  "Mar 25 2026": {
    [NAMES.TROOPS]: 1290960,
    [NAMES.TANKS]: 11806,
    [NAMES.BMP_BTR]: 24274,
    [NAMES.ARTA]: 38746,
    [NAMES.PPO]: 1336,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 196351,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 85151
  },
  "Mar 26 2026": {
    [NAMES.TROOPS]: 1292170,
    [NAMES.TANKS]: 11807,
    [NAMES.BMP_BTR]: 24278,
    [NAMES.ARTA]: 38795,
    [NAMES.PPO]: 1337,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 198389,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 85352
  },
  "Mar 27 2026": {
    [NAMES.TROOPS]: 1293170,
    [NAMES.TANKS]: 11808,
    [NAMES.BMP_BTR]: 24287,
    [NAMES.ARTA]: 38863,
    [NAMES.PPO]: 1337,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 200611,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 85569
  },
  "Mar 28 2026": {
    [NAMES.TROOPS]: 1294470,
    [NAMES.TANKS]: 11812,
    [NAMES.BMP_BTR]: 24297,
    [NAMES.ARTA]: 38936,
    [NAMES.PPO]: 1337,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 202112,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 85796
  },
  "Mar 29 2026": {
    [NAMES.TROOPS]: 1295830,
    [NAMES.TANKS]: 11820,
    [NAMES.BMP_BTR]: 24313,
    [NAMES.ARTA]: 39001,
    [NAMES.PPO]: 1337,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 204060,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 85977
  },
  "Mar 30 2026": {
    [NAMES.TROOPS]: 1296700,
    [NAMES.TANKS]: 11824,
    [NAMES.BMP_BTR]: 24317,
    [NAMES.ARTA]: 39049,
    [NAMES.PPO]: 1337,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 206531,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 86160
  },
  "Mar 31 2026": {
    [NAMES.TROOPS]: 1297670,
    [NAMES.TANKS]: 11826,
    [NAMES.BMP_BTR]: 24324,
    [NAMES.ARTA]: 39110,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 208827,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 86359
  },
  "Apr 01 2026": {
    [NAMES.TROOPS]: 1298730,
    [NAMES.TANKS]: 11828,
    [NAMES.BMP_BTR]: 24327,
    [NAMES.ARTA]: 39169,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 210896,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 86578
  },
  "Apr 02 2026": {
    [NAMES.TROOPS]: 1300030,
    [NAMES.TANKS]: 11830,
    [NAMES.BMP_BTR]: 24334,
    [NAMES.ARTA]: 39228,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 213393,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 86773
  },
  "Apr 03 2026": {
    [NAMES.TROOPS]: 1301260,
    [NAMES.TANKS]: 11833,
    [NAMES.BMP_BTR]: 24340,
    [NAMES.ARTA]: 39293,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 214629,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 86950
  },
  "Apr 04 2026": {
    [NAMES.TROOPS]: 1302370,
    [NAMES.TANKS]: 11835,
    [NAMES.BMP_BTR]: 24344,
    [NAMES.ARTA]: 39378,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 217016,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 87149
  },
  "Apr 05 2026": {
    [NAMES.TROOPS]: 1303550,
    [NAMES.TANKS]: 11839,
    [NAMES.BMP_BTR]: 24350,
    [NAMES.ARTA]: 39439,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 219443,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 87355
  },
  "Apr 06 2026": {
    [NAMES.TROOPS]: 1304490,
    [NAMES.TANKS]: 11841,
    [NAMES.BMP_BTR]: 24360,
    [NAMES.ARTA]: 39497,
    [NAMES.PPO]: 1338,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 221396,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 87614
  },
  "Apr 07 2026": {
    [NAMES.TROOPS]: 1305470,
    [NAMES.TANKS]: 11841,
    [NAMES.BMP_BTR]: 24364,
    [NAMES.ARTA]: 39562,
    [NAMES.PPO]: 1340,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 223341,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 87862
  },
  "Apr 08 2026": {
    [NAMES.TROOPS]: 1306500,
    [NAMES.TANKS]: 11846,
    [NAMES.BMP_BTR]: 24368,
    [NAMES.ARTA]: 39625,
    [NAMES.PPO]: 1341,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 225301,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 88103
  },
  "Apr 09 2026": {
    [NAMES.TROOPS]: 1307540,
    [NAMES.TANKS]: 11847,
    [NAMES.BMP_BTR]: 24370,
    [NAMES.ARTA]: 39689,
    [NAMES.PPO]: 1341,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 227539,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 88332
  },
  "Apr 10 2026": {
    [NAMES.TROOPS]: 1308670,
    [NAMES.TANKS]: 11848,
    [NAMES.BMP_BTR]: 24375,
    [NAMES.ARTA]: 39734,
    [NAMES.PPO]: 1341,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 229771,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 88515
  },
  "Apr 11 2026": {
    [NAMES.TROOPS]: 1310110,
    [NAMES.TANKS]: 11851,
    [NAMES.BMP_BTR]: 24381,
    [NAMES.ARTA]: 39798,
    [NAMES.PPO]: 1344,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 231785,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 88698
  },
  "Apr 12 2026": {
    [NAMES.TROOPS]: 1311180,
    [NAMES.TANKS]: 11859,
    [NAMES.BMP_BTR]: 24384,
    [NAMES.ARTA]: 39871,
    [NAMES.PPO]: 1345,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 233866,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 88914
  },
  "Apr 13 2026": {
    [NAMES.TROOPS]: 1312140,
    [NAMES.TANKS]: 11861,
    [NAMES.BMP_BTR]: 24386,
    [NAMES.ARTA]: 39915,
    [NAMES.PPO]: 1346,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 235394,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 89099
  },
  "Apr 14 2026": {
    [NAMES.TROOPS]: 1312960,
    [NAMES.TANKS]: 11863,
    [NAMES.BMP_BTR]: 24389,
    [NAMES.ARTA]: 39953,
    [NAMES.PPO]: 1346,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 237853,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 89300
  },
  "Apr 15 2026": {
    [NAMES.TROOPS]: 1313970,
    [NAMES.TANKS]: 11864,
    [NAMES.BMP_BTR]: 24390,
    [NAMES.ARTA]: 40003,
    [NAMES.PPO]: 1346,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 239241,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 89553
  },
  "Apr 16 2026": {
    [NAMES.TROOPS]: 1315070,
    [NAMES.TANKS]: 11866,
    [NAMES.BMP_BTR]: 24391,
    [NAMES.ARTA]: 40046,
    [NAMES.PPO]: 1347,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 240598,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 89761
  },
  "Apr 17 2026": {
    [NAMES.TROOPS]: 1316070,
    [NAMES.TANKS]: 11870,
    [NAMES.BMP_BTR]: 24400,
    [NAMES.ARTA]: 40160,
    [NAMES.PPO]: 1349,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 243008,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90014
  },
  "Apr 18 2026": {
    [NAMES.TROOPS]: 1317150,
    [NAMES.TANKS]: 11876,
    [NAMES.BMP_BTR]: 24410,
    [NAMES.ARTA]: 40242,
    [NAMES.PPO]: 1349,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 245112,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90194
  },
  "Apr 19 2026": {
    [NAMES.TROOPS]: 1318220,
    [NAMES.TANKS]: 11882,
    [NAMES.BMP_BTR]: 24420,
    [NAMES.ARTA]: 40324,
    [NAMES.PPO]: 1349,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 247131,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90397
  },
  "Apr 20 2026": {
    [NAMES.TROOPS]: 1319270,
    [NAMES.TANKS]: 11884,
    [NAMES.BMP_BTR]: 24422,
    [NAMES.ARTA]: 40396,
    [NAMES.PPO]: 1350,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 248558,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90571
  },
  "Apr 21 2026": {
    [NAMES.TROOPS]: 1320310,
    [NAMES.TANKS]: 11884,
    [NAMES.BMP_BTR]: 24429,
    [NAMES.ARTA]: 40478,
    [NAMES.PPO]: 1350,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 250463,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90763
  },
  "Apr 22 2026": {
    [NAMES.TROOPS]: 1321450,
    [NAMES.TANKS]: 11885,
    [NAMES.BMP_BTR]: 24436,
    [NAMES.ARTA]: 40516,
    [NAMES.PPO]: 1350,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 251489,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 90925
  },
  "Apr 23 2026": {
    [NAMES.TROOPS]: 1322550,
    [NAMES.TANKS]: 11888,
    [NAMES.BMP_BTR]: 24441,
    [NAMES.ARTA]: 40574,
    [NAMES.PPO]: 1351,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 253430,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91127
  },
  "Apr 24 2026": {
    [NAMES.TROOPS]: 1323460,
    [NAMES.TANKS]: 11892,
    [NAMES.BMP_BTR]: 24445,
    [NAMES.ARTA]: 40606,
    [NAMES.PPO]: 1353,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 254605,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91256
  },
  "Apr 25 2026": {
    [NAMES.TROOPS]: 1324690,
    [NAMES.TANKS]: 11892,
    [NAMES.BMP_BTR]: 24458,
    [NAMES.ARTA]: 40635,
    [NAMES.PPO]: 1353,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 255862,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91422
  },
  "Apr 26 2026": {
    [NAMES.TROOPS]: 1325650,
    [NAMES.TANKS]: 11892,
    [NAMES.BMP_BTR]: 24463,
    [NAMES.ARTA]: 40711,
    [NAMES.PPO]: 1354,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 258091,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91582
  },
  "Apr 27 2026": {
    [NAMES.TROOPS]: 1326460,
    [NAMES.TANKS]: 11892,
    [NAMES.BMP_BTR]: 24467,
    [NAMES.ARTA]: 40737,
    [NAMES.PPO]: 1354,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 259219,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91710
  },
  "Apr 28 2026": {
    [NAMES.TROOPS]: 1327640,
    [NAMES.TANKS]: 11892,
    [NAMES.BMP_BTR]: 24483,
    [NAMES.ARTA]: 40771,
    [NAMES.PPO]: 1354,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 260258,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 91986
  },
  "Apr 29 2026": {
    [NAMES.TROOPS]: 1328820,
    [NAMES.TANKS]: 11894,
    [NAMES.BMP_BTR]: 24486,
    [NAMES.ARTA]: 40825,
    [NAMES.PPO]: 1356,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 350,
    [NAMES.UAV]: 262033,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 92231
  },
  "Apr 30 2026": {
    [NAMES.TROOPS]: 1330290,
    [NAMES.TANKS]: 11901,
    [NAMES.BMP_BTR]: 24493,
    [NAMES.ARTA]: 40944,
    [NAMES.PPO]: 1356,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 263360,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 92606
  },
  "May 01 2026": {
    [NAMES.TROOPS]: 1331710,
    [NAMES.TANKS]: 11903,
    [NAMES.BMP_BTR]: 24496,
    [NAMES.ARTA]: 41044,
    [NAMES.PPO]: 1357,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 265284,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 93009
  },
  "May 02 2026": {
    [NAMES.TROOPS]: 1332950,
    [NAMES.TANKS]: 11906,
    [NAMES.BMP_BTR]: 24500,
    [NAMES.ARTA]: 41117,
    [NAMES.PPO]: 1357,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 267589,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 93274
  },
  "May 03 2026": {
    [NAMES.TROOPS]: 1334030,
    [NAMES.TANKS]: 11908,
    [NAMES.BMP_BTR]: 24503,
    [NAMES.ARTA]: 41193,
    [NAMES.PPO]: 1357,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 269813,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 93556
  },
  "May 04 2026": {
    [NAMES.TROOPS]: 1335150,
    [NAMES.TANKS]: 11914,
    [NAMES.BMP_BTR]: 24507,
    [NAMES.ARTA]: 41306,
    [NAMES.PPO]: 1357,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 272062,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 93824
  },
  "May 05 2026": {
    [NAMES.TROOPS]: 1336120,
    [NAMES.TANKS]: 11917,
    [NAMES.BMP_BTR]: 24510,
    [NAMES.ARTA]: 41386,
    [NAMES.PPO]: 1361,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 274030,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 94030
  },
  "May 06 2026": {
    [NAMES.TROOPS]: 1337170,
    [NAMES.TANKS]: 11918,
    [NAMES.BMP_BTR]: 24515,
    [NAMES.ARTA]: 41478,
    [NAMES.PPO]: 1363,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 276061,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 94312
  },
  "May 07 2026": {
    [NAMES.TROOPS]: 1338060,
    [NAMES.TANKS]: 11918,
    [NAMES.BMP_BTR]: 24521,
    [NAMES.ARTA]: 41539,
    [NAMES.PPO]: 1365,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 277912,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 94545
  },
  "May 08 2026": {
    [NAMES.TROOPS]: 1339190,
    [NAMES.TANKS]: 11919,
    [NAMES.BMP_BTR]: 24538,
    [NAMES.ARTA]: 41630,
    [NAMES.PPO]: 1370,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 279729,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 94879
  },
  "May 09 2026": {
    [NAMES.TROOPS]: 1340270,
    [NAMES.TANKS]: 11920,
    [NAMES.BMP_BTR]: 24541,
    [NAMES.ARTA]: 41712,
    [NAMES.PPO]: 1371,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 281208,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 95252
  },
  "May 10 2026": {
    [NAMES.TROOPS]: 1341110,
    [NAMES.TANKS]: 11920,
    [NAMES.BMP_BTR]: 24544,
    [NAMES.ARTA]: 41787,
    [NAMES.PPO]: 1373,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 282697,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 95479
  },
  "May 11 2026": {
    [NAMES.TROOPS]: 1342030,
    [NAMES.TANKS]: 11924,
    [NAMES.BMP_BTR]: 24551,
    [NAMES.ARTA]: 41863,
    [NAMES.PPO]: 1373,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 284254,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 95710
  },
  "May 12 2026": {
    [NAMES.TROOPS]: 1343050,
    [NAMES.TANKS]: 11926,
    [NAMES.BMP_BTR]: 24553,
    [NAMES.ARTA]: 41935,
    [NAMES.PPO]: 1373,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 285506,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 95855
  },
  "May 13 2026": {
    [NAMES.TROOPS]: 1344180,
    [NAMES.TANKS]: 11928,
    [NAMES.BMP_BTR]: 24554,
    [NAMES.ARTA]: 41985,
    [NAMES.PPO]: 1376,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 287359,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 96142
  },
  "May 14 2026": {
    [NAMES.TROOPS]: 1345240,
    [NAMES.TANKS]: 11931,
    [NAMES.BMP_BTR]: 24557,
    [NAMES.ARTA]: 42053,
    [NAMES.PPO]: 1379,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 289678,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 96355
  },
  "May 15 2026": {
    [NAMES.TROOPS]: 1346390,
    [NAMES.TANKS]: 11935,
    [NAMES.BMP_BTR]: 24569,
    [NAMES.ARTA]: 42085,
    [NAMES.PPO]: 1379,
    [NAMES.JETS]: 435,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 291458,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 96540
  },
  "May 16 2026": {
    [NAMES.TROOPS]: 1347620,
    [NAMES.TANKS]: 11937,
    [NAMES.BMP_BTR]: 24574,
    [NAMES.ARTA]: 42133,
    [NAMES.PPO]: 1381,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 293323,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 96793
  },
  "May 17 2026": {
    [NAMES.TROOPS]: 1348790,
    [NAMES.TANKS]: 11938,
    [NAMES.BMP_BTR]: 24578,
    [NAMES.ARTA]: 42215,
    [NAMES.PPO]: 1384,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 352,
    [NAMES.UAV]: 295454,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 97118
  },
  "May 18 2026": {
    [NAMES.TROOPS]: 1350010,
    [NAMES.TANKS]: 11939,
    [NAMES.BMP_BTR]: 24583,
    [NAMES.ARTA]: 42262,
    [NAMES.PPO]: 1386,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 297057,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 97338
  },
  "May 19 2026": {
    [NAMES.TROOPS]: 1351150,
    [NAMES.TANKS]: 11940,
    [NAMES.BMP_BTR]: 24584,
    [NAMES.ARTA]: 42340,
    [NAMES.PPO]: 1386,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 299199,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 97600
  },
  "May 20 2026": {
    [NAMES.TROOPS]: 1352070,
    [NAMES.TANKS]: 11943,
    [NAMES.BMP_BTR]: 24586,
    [NAMES.ARTA]: 42400,
    [NAMES.PPO]: 1388,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 301072,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 97868
  },
  "May 21 2026": {
    [NAMES.TROOPS]: 1352980,
    [NAMES.TANKS]: 11943,
    [NAMES.BMP_BTR]: 24591,
    [NAMES.ARTA]: 42454,
    [NAMES.PPO]: 1389,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 302787,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 98070
  },
  "May 22 2026": {
    [NAMES.TROOPS]: 1353860,
    [NAMES.TANKS]: 11944,
    [NAMES.BMP_BTR]: 24594,
    [NAMES.ARTA]: 42511,
    [NAMES.PPO]: 1390,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 304659,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 98205
  },
  "May 23 2026": {
    [NAMES.TROOPS]: 1354810,
    [NAMES.TANKS]: 11949,
    [NAMES.BMP_BTR]: 24599,
    [NAMES.ARTA]: 42579,
    [NAMES.PPO]: 1394,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 306478,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 98406
  },
  "May 24 2026": {
    [NAMES.TROOPS]: 1355920,
    [NAMES.TANKS]: 11950,
    [NAMES.BMP_BTR]: 24603,
    [NAMES.ARTA]: 42640,
    [NAMES.PPO]: 1396,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 308321,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 98698
  },
  "May 25 2026": {
    [NAMES.TROOPS]: 1356940,
    [NAMES.TANKS]: 11953,
    [NAMES.BMP_BTR]: 24608,
    [NAMES.ARTA]: 42687,
    [NAMES.PPO]: 1396,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 310245,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 99000
  },
  "May 26 2026": {
    [NAMES.TROOPS]: 1357950,
    [NAMES.TANKS]: 11954,
    [NAMES.BMP_BTR]: 24615,
    [NAMES.ARTA]: 42751,
    [NAMES.PPO]: 1397,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 312035,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 99374
  },
  "May 27 2026": {
    [NAMES.TROOPS]: 1358950,
    [NAMES.TANKS]: 11955,
    [NAMES.BMP_BTR]: 24618,
    [NAMES.ARTA]: 42790,
    [NAMES.PPO]: 1397,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 313342,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 99645
  },
  "May 28 2026": {
    [NAMES.TROOPS]: 1360110,
    [NAMES.TANKS]: 11956,
    [NAMES.BMP_BTR]: 24625,
    [NAMES.ARTA]: 42832,
    [NAMES.PPO]: 1397,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 314902,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 99906
  },
  "May 29 2026": {
    [NAMES.TROOPS]: 1361070,
    [NAMES.TANKS]: 11958,
    [NAMES.BMP_BTR]: 24636,
    [NAMES.ARTA]: 42860,
    [NAMES.PPO]: 1397,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 316652,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 100230
  },
  "May 30 2026": {
    [NAMES.TROOPS]: 1362500,
    [NAMES.TANKS]: 11960,
    [NAMES.BMP_BTR]: 24643,
    [NAMES.ARTA]: 42930,
    [NAMES.PPO]: 1398,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 318433,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 100713
  },
  "May 31 2026": {
    [NAMES.TROOPS]: 1364060,
    [NAMES.TANKS]: 11962,
    [NAMES.BMP_BTR]: 24657,
    [NAMES.ARTA]: 42987,
    [NAMES.PPO]: 1399,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 320327,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 101237
  },
  "Jun 01 2026": {
    [NAMES.TROOPS]: 1365470,
    [NAMES.TANKS]: 11966,
    [NAMES.BMP_BTR]: 24659,
    [NAMES.ARTA]: 43037,
    [NAMES.PPO]: 1399,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 322179,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 101621
  },
  "Jun 02 2026": {
    [NAMES.TROOPS]: 1366910,
    [NAMES.TANKS]: 11969,
    [NAMES.BMP_BTR]: 24666,
    [NAMES.ARTA]: 43112,
    [NAMES.PPO]: 1400,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 323762,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 102138
  },
  "Jun 3 2026": {
    [NAMES.TROOPS]: 1368040,
    [NAMES.TANKS]: 11974,
    [NAMES.BMP_BTR]: 24673,
    [NAMES.ARTA]: 43172,
    [NAMES.PPO]: 1403,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 325615,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 102575
  },
  "Jun 4 2026": {
    [NAMES.TROOPS]: 1369340,
    [NAMES.TANKS]: 11978,
    [NAMES.BMP_BTR]: 24676,
    [NAMES.ARTA]: 43247,
    [NAMES.PPO]: 1403,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 327726,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 102971
  },
  "Jun 5 2026": {
    [NAMES.TROOPS]: 1370890,
    [NAMES.TANKS]: 11980,
    [NAMES.BMP_BTR]: 24684,
    [NAMES.ARTA]: 43315,
    [NAMES.PPO]: 1404,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 329772,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 103300
  },
  "Jun 6 2026": {
    [NAMES.TROOPS]: 1372270,
    [NAMES.TANKS]: 11983,
    [NAMES.BMP_BTR]: 24696,
    [NAMES.ARTA]: 43397,
    [NAMES.PPO]: 1405,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 331818,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 103658
  },
  "Jun 7 2026": {
    [NAMES.TROOPS]: 1373620,
    [NAMES.TANKS]: 11989,
    [NAMES.BMP_BTR]: 24700,
    [NAMES.ARTA]: 43479,
    [NAMES.PPO]: 1407,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 334063,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 104051
  },
  "Jun 8 2026": {
    [NAMES.TROOPS]: 1374950,
    [NAMES.TANKS]: 11997,
    [NAMES.BMP_BTR]: 24705,
    [NAMES.ARTA]: 43564,
    [NAMES.PPO]: 1409,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 336224,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 104414
  },
  "Jun 9 2026": {
    [NAMES.TROOPS]: 1376320,
    [NAMES.TANKS]: 12001,
    [NAMES.BMP_BTR]: 24710,
    [NAMES.ARTA]: 43639,
    [NAMES.PPO]: 1411,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 338327,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 104796
  },
  "Jun 10 2026": {
    [NAMES.TROOPS]: 1377510,
    [NAMES.TANKS]: 12004,
    [NAMES.BMP_BTR]: 24717,
    [NAMES.ARTA]: 43713,
    [NAMES.PPO]: 1414,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 340531,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 105172
  },
  "Jun 11 2026": {
    [NAMES.TROOPS]: 1378820,
    [NAMES.TANKS]: 12010,
    [NAMES.BMP_BTR]: 24727,
    [NAMES.ARTA]: 43787,
    [NAMES.PPO]: 1416,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 342651,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 105498
  },
  "Jun 12 2026": {
    [NAMES.TROOPS]: 1380120,
    [NAMES.TANKS]: 12014,
    [NAMES.BMP_BTR]: 24728,
    [NAMES.ARTA]: 43865,
    [NAMES.PPO]: 1417,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 344869,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 105850
  },
  "Jun 13 2026": {
    [NAMES.TROOPS]: 1381430,
    [NAMES.TANKS]: 12015,
    [NAMES.BMP_BTR]: 24739,
    [NAMES.ARTA]: 43953,
    [NAMES.PPO]: 1418,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 347033,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 106274
  },
  "Jun 14 2026": {
    [NAMES.TROOPS]: 1382870,
    [NAMES.TANKS]: 12020,
    [NAMES.BMP_BTR]: 24753,
    [NAMES.ARTA]: 44010,
    [NAMES.PPO]: 1419,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 349165,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 106675
  },
  "Jun 15 2026": {
    [NAMES.TROOPS]: 1384190,
    [NAMES.TANKS]: 12025,
    [NAMES.BMP_BTR]: 24763,
    [NAMES.ARTA]: 44082,
    [NAMES.PPO]: 1420,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 351479,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 107091
  },
  "Jun 16 2026": {
    [NAMES.TROOPS]: 1385420,
    [NAMES.TANKS]: 12026,
    [NAMES.BMP_BTR]: 24768,
    [NAMES.ARTA]: 44118,
    [NAMES.PPO]: 1427,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 353541,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 107508
  },
  "Jun 17 2026": {
    [NAMES.TROOPS]: 1386680,
    [NAMES.TANKS]: 12033,
    [NAMES.BMP_BTR]: 24775,
    [NAMES.ARTA]: 44169,
    [NAMES.PPO]: 1427,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 355593,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 107994
  },
  "Jun 18 2026": {
    [NAMES.TROOPS]: 1388050,
    [NAMES.TANKS]: 12038,
    [NAMES.BMP_BTR]: 24779,
    [NAMES.ARTA]: 44240,
    [NAMES.PPO]: 1431,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 357589,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 108425
  },
  "Jun 19 2026": {
    [NAMES.TROOPS]: 1389420,
    [NAMES.TANKS]: 12040,
    [NAMES.BMP_BTR]: 24783,
    [NAMES.ARTA]: 44298,
    [NAMES.PPO]: 1432,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 359557,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 108866
  },
  "Jun 20 2026": {
    [NAMES.TROOPS]: 1390660,
    [NAMES.TANKS]: 12041,
    [NAMES.BMP_BTR]: 24787,
    [NAMES.ARTA]: 44386,
    [NAMES.PPO]: 1433,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 361803,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 109342
  },
  "Jun 21 2026": {
    [NAMES.TROOPS]: 1391950,
    [NAMES.TANKS]: 12049,
    [NAMES.BMP_BTR]: 24797,
    [NAMES.ARTA]: 44479,
    [NAMES.PPO]: 1435,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 364149,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 109817
  },
  "Jun 22 2026": {
    [NAMES.TROOPS]: 1393140,
    [NAMES.TANKS]: 12050,
    [NAMES.BMP_BTR]: 24805,
    [NAMES.ARTA]: 44530,
    [NAMES.PPO]: 1437,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 366164,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 110201
  },
  "Jun 23 2026": {
    [NAMES.TROOPS]: 1394530,
    [NAMES.TANKS]: 12050,
    [NAMES.BMP_BTR]: 24812,
    [NAMES.ARTA]: 44604,
    [NAMES.PPO]: 1437,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 368015,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 110827
  },
  "Jun 24 2026": {
    [NAMES.TROOPS]: 1395790,
    [NAMES.TANKS]: 12056,
    [NAMES.BMP_BTR]: 24816,
    [NAMES.ARTA]: 44664,
    [NAMES.PPO]: 1440,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 369888,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 111257
  },
  "Jun 25 2026": {
    [NAMES.TROOPS]: 1397060,
    [NAMES.TANKS]: 12057,
    [NAMES.BMP_BTR]: 24818,
    [NAMES.ARTA]: 44731,
    [NAMES.PPO]: 1443,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 371882,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 111707
  },
  "Jun 26 2026": {
    [NAMES.TROOPS]: 1398370,
    [NAMES.TANKS]: 12059,
    [NAMES.BMP_BTR]: 24823,
    [NAMES.ARTA]: 44799,
    [NAMES.PPO]: 1447,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 373660,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 112146
  },
  "Jun 27 2026": {
    [NAMES.TROOPS]: 1399720,
    [NAMES.TANKS]: 12060,
    [NAMES.BMP_BTR]: 24835,
    [NAMES.ARTA]: 44857,
    [NAMES.PPO]: 1447,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 375611,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 112634
  },
  "Jun 28 2026": {
    [NAMES.TROOPS]: 1400970,
    [NAMES.TANKS]: 12063,
    [NAMES.BMP_BTR]: 24844,
    [NAMES.ARTA]: 44920,
    [NAMES.PPO]: 1454,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 377500,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 113135
  },
  "Jun 29 2026": {
    [NAMES.TROOPS]: 1402200,
    [NAMES.TANKS]: 12066,
    [NAMES.BMP_BTR]: 24845,
    [NAMES.ARTA]: 44969,
    [NAMES.PPO]: 1454,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 379224,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 113612
  },
  "Jun 30 2026": {
    [NAMES.TROOPS]: 1403550,
    [NAMES.TANKS]: 12067,
    [NAMES.BMP_BTR]: 24851,
    [NAMES.ARTA]: 45040,
    [NAMES.PPO]: 1455,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 381176,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 114104
  },

  "Jul 1 2026": {
    [NAMES.TROOPS]: 1404760,
    [NAMES.TANKS]: 12069,
    [NAMES.BMP_BTR]: 24856,
    [NAMES.ARTA]: 45111,
    [NAMES.PPO]: 1459,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 383067,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 114499
  },
  "Jul 2 2026": {
    [NAMES.TROOPS]: 1405900,
    [NAMES.TANKS]: 12069,
    [NAMES.BMP_BTR]: 24861,
    [NAMES.ARTA]: 45168,
    [NAMES.PPO]: 1459,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 385190,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 114852
  },
  "Jul 3 2026": {
    [NAMES.TROOPS]: 1407150,
    [NAMES.TANKS]: 12073,
    [NAMES.BMP_BTR]: 24863,
    [NAMES.ARTA]: 45225,
    [NAMES.PPO]: 1463,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 387342,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 115237
  },
  "Jul 4 2026": {
    [NAMES.TROOPS]: 1408340,
    [NAMES.TANKS]: 12074,
    [NAMES.BMP_BTR]: 24869,
    [NAMES.ARTA]: 45325,
    [NAMES.PPO]: 1469,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 389110,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 115644
  },
  "Jul 5 2026": {
    [NAMES.TROOPS]: 1409630,
    [NAMES.TANKS]: 12081,
    [NAMES.BMP_BTR]: 24878,
    [NAMES.ARTA]: 45388,
    [NAMES.PPO]: 1470,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 390738,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 116106
  },
  "Jul 6 2026": {
    [NAMES.TROOPS]: 1411050,
    [NAMES.TANKS]: 12088,
    [NAMES.BMP_BTR]: 24894,
    [NAMES.ARTA]: 45451,
    [NAMES.PPO]: 1473,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 392717,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 116686
  },
  "Jul 7 2026": {
    [NAMES.TROOPS]: 1412250,
    [NAMES.TANKS]: 12097,
    [NAMES.BMP_BTR]: 24899,
    [NAMES.ARTA]: 45508,
    [NAMES.PPO]: 1478,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 394846,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 117085
  },
  "Jul 8 2026": {
    [NAMES.TROOPS]: 1413510,
    [NAMES.TANKS]: 12100,
    [NAMES.BMP_BTR]: 24903,
    [NAMES.ARTA]: 45569,
    [NAMES.PPO]: 1478,
    [NAMES.JETS]: 436,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 396920,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 117547
  },
  "Jul 9 2026": {
    [NAMES.TROOPS]: 1414820,
    [NAMES.TANKS]: 12107,
    [NAMES.BMP_BTR]: 24906,
    [NAMES.ARTA]: 45628,
    [NAMES.PPO]: 1479,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 398763,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 117910
  },
  "Jul 10 2026": {
    [NAMES.TROOPS]: 1416280,
    [NAMES.TANKS]: 12108,
    [NAMES.BMP_BTR]: 24912,
    [NAMES.ARTA]: 45680,
    [NAMES.PPO]: 1481,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 400631,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 118249
  },
  "Jul 11 2026": {
    [NAMES.TROOPS]: 1417770,
    [NAMES.TANKS]: 12116,
    [NAMES.BMP_BTR]: 24922,
    [NAMES.ARTA]: 45754,
    [NAMES.PPO]: 1485,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 401925,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 118610
  },
  "Jul 12 2026": {
    [NAMES.TROOPS]: 1419090,
    [NAMES.TANKS]: 12120,
    [NAMES.BMP_BTR]: 24928,
    [NAMES.ARTA]: 45807,
    [NAMES.PPO]: 1485,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 403959,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 119038
  },
  "Jul 13 2026": {
    [NAMES.TROOPS]: 1420690,
    [NAMES.TANKS]: 12125,
    [NAMES.BMP_BTR]: 24931,
    [NAMES.ARTA]: 45865,
    [NAMES.PPO]: 1489,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 405693,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 119532
  },
  "Jul 14 2026": {
    [NAMES.TROOPS]: 1421810,
    [NAMES.TANKS]: 12131,
    [NAMES.BMP_BTR]: 24932,
    [NAMES.ARTA]: 45911,
    [NAMES.PPO]: 1491,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 407201,
    [NAMES.SHIPS]: 35,
    [NAMES.AUTO]: 119862
  },
  "Jul 15 2026": {
    [NAMES.TROOPS]: 1423280,
    [NAMES.TANKS]: 12141,
    [NAMES.BMP_BTR]: 24938,
    [NAMES.ARTA]: 45953,
    [NAMES.PPO]: 1492,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 409204,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 120307
  },
  "Jul 16 2026": {
    [NAMES.TROOPS]: 1424620,
    [NAMES.TANKS]: 12144,
    [NAMES.BMP_BTR]: 24940,
    [NAMES.ARTA]: 46019,
    [NAMES.PPO]: 1492,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 353,
    [NAMES.UAV]: 411005,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 120727
  },
  "Jul 17 2026": {
    [NAMES.TROOPS]: 1425990,
    [NAMES.TANKS]: 12148,
    [NAMES.BMP_BTR]: 24946,
    [NAMES.ARTA]: 46084,
    [NAMES.PPO]: 1496,
    [NAMES.JETS]: 437,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 412884,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 121216
  },
  "Jul 18 2026": {
    [NAMES.TROOPS]: 1427410,
    [NAMES.TANKS]: 12151,
    [NAMES.BMP_BTR]: 24956,
    [NAMES.ARTA]: 46169,
    [NAMES.PPO]: 1502,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 414798,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 121742
  },
  "Jul 19 2026": {
    [NAMES.TROOPS]: 1428930,
    [NAMES.TANKS]: 12156,
    [NAMES.BMP_BTR]: 24963,
    [NAMES.ARTA]: 46261,
    [NAMES.PPO]: 1505,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 416656,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 122289
  },
  "Jul 20 2026": {
    [NAMES.TROOPS]: 1430530,
    [NAMES.TANKS]: 12158,
    [NAMES.BMP_BTR]: 24971,
    [NAMES.ARTA]: 46343,
    [NAMES.PPO]: 1511,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 418425,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 122894
  },
  "Jul 21 2026": {
    [NAMES.TROOPS]: 1431900,
    [NAMES.TANKS]: 12161,
    [NAMES.BMP_BTR]: 24978,
    [NAMES.ARTA]: 46435,
    [NAMES.PPO]: 1513,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 420290,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 123347
  },
  "Jul 22 2026": {
    [NAMES.TROOPS]: 1433230,
    [NAMES.TANKS]: 12163,
    [NAMES.BMP_BTR]: 24982,
    [NAMES.ARTA]: 46492,
    [NAMES.PPO]: 1513,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 421900,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 123702
  },
  "Jul 23 2026": {
    [NAMES.TROOPS]: 1434690,
    [NAMES.TANKS]: 12191,
    [NAMES.BMP_BTR]: 24994,
    [NAMES.ARTA]: 46570,
    [NAMES.PPO]: 1515,
    [NAMES.JETS]: 438,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 423588,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 124243
  },
  "Jul 24 2026": {
    [NAMES.TROOPS]: 1436100,
    [NAMES.TANKS]: 12201,
    [NAMES.BMP_BTR]: 25000,
    [NAMES.ARTA]: 46646,
    [NAMES.PPO]: 1516,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 425240,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 124787
  },
  "Jul 25 2026": {
    [NAMES.TROOPS]: 1437550,
    [NAMES.TANKS]: 12208,
    [NAMES.BMP_BTR]: 25011,
    [NAMES.ARTA]: 46724,
    [NAMES.PPO]: 1518,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 426836,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 125358
  },
  "Jul 26 2026": {
    [NAMES.TROOPS]: 1438990,
    [NAMES.TANKS]: 12217,
    [NAMES.BMP_BTR]: 25019,
    [NAMES.ARTA]: 46794,
    [NAMES.PPO]: 1518,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 428286,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 125811
  },
  "Jul 27 2026": {
    [NAMES.TROOPS]: 1440580,
    [NAMES.TANKS]: 12225,
    [NAMES.BMP_BTR]: 25032,
    [NAMES.ARTA]: 46831,
    [NAMES.PPO]: 1519,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 429555,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 126302
  },
  "Jul 28 2026": {
    [NAMES.TROOPS]: 1442140,
    [NAMES.TANKS]: 12226,
    [NAMES.BMP_BTR]: 25038,
    [NAMES.ARTA]: 46902,
    [NAMES.PPO]: 1519,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 431310,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 126850
  },
  "Jul 29 2026": {
    [NAMES.TROOPS]: 1443450,
    [NAMES.TANKS]: 12227,
    [NAMES.BMP_BTR]: 25044,
    [NAMES.ARTA]: 46962,
    [NAMES.PPO]: 1521,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 432778,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 127181
  },
  "Jul 30 2026": {
    [NAMES.TROOPS]: 1444810,
    [NAMES.TANKS]: 12230,
    [NAMES.BMP_BTR]: 25049,
    [NAMES.ARTA]: 47003,
    [NAMES.PPO]: 1522,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 434140,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 127621
  },
  "Jul 31 2026": {
    [NAMES.TROOPS]: 1446150,
    [NAMES.TANKS]: 12231,
    [NAMES.BMP_BTR]: 25056,
    [NAMES.ARTA]: 47045,
    [NAMES.PPO]: 1525,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 435665,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 128034
  },

  "Aug 1 2026": {
    [NAMES.TROOPS]: 1447620,
    [NAMES.TANKS]: 12231,
    [NAMES.BMP_BTR]: 25060,
    [NAMES.ARTA]: 47127,
    [NAMES.PPO]: 1527,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 437503,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 128497
  },
  "Aug 2 2026": {
    [NAMES.TROOPS]: 1449120,
    [NAMES.TANKS]: 12231,
    [NAMES.BMP_BTR]: 25070,
    [NAMES.ARTA]: 47196,
    [NAMES.PPO]: 1529,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 439291,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 128953
  },
  "Aug 3 2026": {
    [NAMES.TROOPS]: 1450510,
    [NAMES.TANKS]: 12232,
    [NAMES.BMP_BTR]: 25075,
    [NAMES.ARTA]: 47276,
    [NAMES.PPO]: 1533,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 440948,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 129438
  },
  "Aug 4 2026": {
    [NAMES.TROOPS]: 1451750,
    [NAMES.TANKS]: 12237,
    [NAMES.BMP_BTR]: 25079,
    [NAMES.ARTA]: 47331,
    [NAMES.PPO]: 1538,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 442740,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 129817
  },
  "Aug 5 2026": {
    [NAMES.TROOPS]: 1452880,
    [NAMES.TANKS]: 12242,
    [NAMES.BMP_BTR]: 25084,
    [NAMES.ARTA]: 47396,
    [NAMES.PPO]: 1540,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 444455,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 130266
  },
  "Aug 6 2026": {
    [NAMES.TROOPS]: 1454210,
    [NAMES.TANKS]: 12246,
    [NAMES.BMP_BTR]: 25087,
    [NAMES.ARTA]: 47455,
    [NAMES.PPO]: 1547,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 446266,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 130682
  },
  "Aug 7 2026": {
    [NAMES.TROOPS]: 1455420,
    [NAMES.TANKS]: 12247,
    [NAMES.BMP_BTR]: 25098,
    [NAMES.ARTA]: 47522,
    [NAMES.PPO]: 1550,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 447855,
    [NAMES.SHIPS]: 36,
    [NAMES.AUTO]: 131068
  },
  "Aug 8 2026": {
    [NAMES.TROOPS]: 1456610,
    [NAMES.TANKS]: 12251,
    [NAMES.BMP_BTR]: 25099,
    [NAMES.ARTA]: 47580,
    [NAMES.PPO]: 1556,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 449606,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 131417
  },
  "Aug 9 2026": {
    [NAMES.TROOPS]: 1457740,
    [NAMES.TANKS]: 12253,
    [NAMES.BMP_BTR]: 25103,
    [NAMES.ARTA]: 47621,
    [NAMES.PPO]: 1556,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 451248,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 131775
  },
  "Aug 10 2026": {
    [NAMES.TROOPS]: 1459210,
    [NAMES.TANKS]: 12255,
    [NAMES.BMP_BTR]: 25116,
    [NAMES.ARTA]: 47669,
    [NAMES.PPO]: 1558,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 452994,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 132236
  },
  "Aug 11 2026": {
    [NAMES.TROOPS]: 1460400,
    [NAMES.TANKS]: 12259,
    [NAMES.BMP_BTR]: 25120,
    [NAMES.ARTA]: 47713,
    [NAMES.PPO]: 1560,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 454572,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 132543
  },
  "Aug 12 2026": {
    [NAMES.TROOPS]: 1461660,
    [NAMES.TANKS]: 12259,
    [NAMES.BMP_BTR]: 25127,
    [NAMES.ARTA]: 47773,
    [NAMES.PPO]: 1561,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 456339,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 132931
  },
  "Aug 13 2026": {
    [NAMES.TROOPS]: 1462970,
    [NAMES.TANKS]: 12262,
    [NAMES.BMP_BTR]: 25130,
    [NAMES.ARTA]: 47824,
    [NAMES.PPO]: 1562,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 457973,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 133405
  },
  "Aug 14 2026": {
    [NAMES.TROOPS]: 1464440,
    [NAMES.TANKS]: 12264,
    [NAMES.BMP_BTR]: 25141,
    [NAMES.ARTA]: 47870,
    [NAMES.PPO]: 1565,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 459649,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 133853
  },
  "Aug 15 2026": {
    [NAMES.TROOPS]: 1465810,
    [NAMES.TANKS]: 12269,
    [NAMES.BMP_BTR]: 25144,
    [NAMES.ARTA]: 47932,
    [NAMES.PPO]: 1568,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 461484,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 134375
  },
  "Aug 16 2026": {
    [NAMES.TROOPS]: 1467320,
    [NAMES.TANKS]: 12270,
    [NAMES.BMP_BTR]: 25151,
    [NAMES.ARTA]: 48007,
    [NAMES.PPO]: 1570,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 463404,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 134851
  },
  "Aug 17 2026": {
    [NAMES.TROOPS]: 1468760,
    [NAMES.TANKS]: 12272,
    [NAMES.BMP_BTR]: 25155,
    [NAMES.ARTA]: 48100,
    [NAMES.PPO]: 1572,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 465497,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 135448
  },
  "Aug 18 2026": {
    [NAMES.TROOPS]: 1469970,
    [NAMES.TANKS]: 12274,
    [NAMES.BMP_BTR]: 25162,
    [NAMES.ARTA]: 48155,
    [NAMES.PPO]: 1577,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 467459,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 135891
  },
  "Aug 19 2026": {
    [NAMES.TROOPS]: 1471160,
    [NAMES.TANKS]: 12276,
    [NAMES.BMP_BTR]: 25162,
    [NAMES.ARTA]: 48205,
    [NAMES.PPO]: 1577,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 469197,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 136318
  },
  "Aug 20 2026": {
    [NAMES.TROOPS]: 1472640,
    [NAMES.TANKS]: 12283,
    [NAMES.BMP_BTR]: 25165,
    [NAMES.ARTA]: 48261,
    [NAMES.PPO]: 1577,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 470869,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 136818
  },
  "Aug 21 2026": {
    [NAMES.TROOPS]: 1474030,
    [NAMES.TANKS]: 12286,
    [NAMES.BMP_BTR]: 25170,
    [NAMES.ARTA]: 48318,
    [NAMES.PPO]: 1581,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 472849,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 137369
  },
  "Aug 22 2026": {
    [NAMES.TROOPS]: 1475270,
    [NAMES.TANKS]: 12292,
    [NAMES.BMP_BTR]: 25176,
    [NAMES.ARTA]: 48382,
    [NAMES.PPO]: 1584,
    [NAMES.JETS]: 439,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 474641,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 137804
  },
  "Aug 23 2026": {
    [NAMES.TROOPS]: 1476580,
    [NAMES.TANKS]: 12292,
    [NAMES.BMP_BTR]: 25202,
    [NAMES.ARTA]: 48451,
    [NAMES.PPO]: 1585,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 476566,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 138219
  },
  "Aug 24 2026": {
    [NAMES.TROOPS]: 1478070,
    [NAMES.TANKS]: 12293,
    [NAMES.BMP_BTR]: 25211,
    [NAMES.ARTA]: 48519,
    [NAMES.PPO]: 1586,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 478327,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 138773
  },
  "Aug 25 2026": {
    [NAMES.TROOPS]: 1479300,
    [NAMES.TANKS]: 12293,
    [NAMES.BMP_BTR]: 25220,
    [NAMES.ARTA]: 48567,
    [NAMES.PPO]: 1587,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 479882,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 139221
  },
  "Aug 26 2026": {
    [NAMES.TROOPS]: 1480750,
    [NAMES.TANKS]: 12300,
    [NAMES.BMP_BTR]: 25230,
    [NAMES.ARTA]: 48641,
    [NAMES.PPO]: 1588,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 481605,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 139754
  },
  "Aug 27 2026": {
    [NAMES.TROOPS]: 1482150,
    [NAMES.TANKS]: 12304,
    [NAMES.BMP_BTR]: 25237,
    [NAMES.ARTA]: 48694,
    [NAMES.PPO]: 1590,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 483367,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 140248
  },
  "Aug 28 2026": {
    [NAMES.TROOPS]: 1483780,
    [NAMES.TANKS]: 12307,
    [NAMES.BMP_BTR]: 25237,
    [NAMES.ARTA]: 48749,
    [NAMES.PPO]: 1593,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 485024,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 140741
  },
  "Aug 29 2026": {
    [NAMES.TROOPS]: 1485200,
    [NAMES.TANKS]: 12310,
    [NAMES.BMP_BTR]: 25241,
    [NAMES.ARTA]: 48774,
    [NAMES.PPO]: 1593,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 486384,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 141059
  },
  "Aug 30 2026": {
    [NAMES.TROOPS]: 1486600,
    [NAMES.TANKS]: 12311,
    [NAMES.BMP_BTR]: 25248,
    [NAMES.ARTA]: 48833,
    [NAMES.PPO]: 1594,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 488347,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 141453
  },
  "Aug 31 2026": {
    [NAMES.TROOPS]: 1488200,
    [NAMES.TANKS]: 12316,
    [NAMES.BMP_BTR]: 25255,
    [NAMES.ARTA]: 48883,
    [NAMES.PPO]: 1597,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 490402,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 141920
  },

  "Sep 1 2026": {
    [NAMES.TROOPS]: 1489640,
    [NAMES.TANKS]: 12320,
    [NAMES.BMP_BTR]: 25257,
    [NAMES.ARTA]: 48954,
    [NAMES.PPO]: 1597,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 492177,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 142332
  },
  "Sep 2 2026": {
    [NAMES.TROOPS]: 1491030,
    [NAMES.TANKS]: 12324,
    [NAMES.BMP_BTR]: 25263,
    [NAMES.ARTA]: 49016,
    [NAMES.PPO]: 1598,
    [NAMES.JETS]: 440,
    [NAMES.HELI]: 354,
    [NAMES.UAV]: 494146,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 142715
  },
  "Sep 3 2026": {
    [NAMES.TROOPS]: 1492350,
    [NAMES.TANKS]: 12324,
    [NAMES.BMP_BTR]: 25264,
    [NAMES.ARTA]: 49085,
    [NAMES.PPO]: 1600,
    [NAMES.JETS]: 441,
    [NAMES.HELI]: 355,
    [NAMES.UAV]: 496021,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 143150
  },
  "Sep 4 2026": {
    [NAMES.TROOPS]: 1493790,
    [NAMES.TANKS]: 12325,
    [NAMES.BMP_BTR]: 25272,
    [NAMES.ARTA]: 49162,
    [NAMES.PPO]: 1604,
    [NAMES.JETS]: 441,
    [NAMES.HELI]: 355,
    [NAMES.UAV]: 497911,
    [NAMES.SHIPS]: 37,
    [NAMES.AUTO]: 143642
  },
};
